var AcceptEscalationResultStatus;
(function (AcceptEscalationResultStatus) {
    AcceptEscalationResultStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
    AcceptEscalationResultStatus["ACCEPTED"] = "ACCEPTED";
    AcceptEscalationResultStatus["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
    AcceptEscalationResultStatus["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
})(AcceptEscalationResultStatus || (AcceptEscalationResultStatus = {}));
var AcceptRequestMode;
(function (AcceptRequestMode) {
    AcceptRequestMode["ALWAYS"] = "ALWAYS";
    AcceptRequestMode["WHEN_ACTIVATED"] = "WHEN_ACTIVATED";
    AcceptRequestMode["WHEN_ACTIVATED_AND_AS_BACKUP"] = "WHEN_ACTIVATED_AND_AS_BACKUP";
})(AcceptRequestMode || (AcceptRequestMode = {}));
var AirportType;
(function (AirportType) {
    AirportType["LARGE_AIRPORT"] = "LARGE_AIRPORT";
    AirportType["MEDIUM_AIRPORT"] = "MEDIUM_AIRPORT";
    AirportType["SMALL_AIRPORT"] = "SMALL_AIRPORT";
})(AirportType || (AirportType = {}));
var ArticleContentBlockType;
(function (ArticleContentBlockType) {
    ArticleContentBlockType["RICH_TEXT"] = "RICH_TEXT";
    ArticleContentBlockType["MEDIA_FILE"] = "MEDIA_FILE";
    ArticleContentBlockType["EMBED_MEDIA"] = "EMBED_MEDIA";
    ArticleContentBlockType["SELLABLE"] = "SELLABLE";
    ArticleContentBlockType["SELLABLE_LIST"] = "SELLABLE_LIST";
})(ArticleContentBlockType || (ArticleContentBlockType = {}));
var ArticleRevisionState;
(function (ArticleRevisionState) {
    ArticleRevisionState["DRAFT"] = "DRAFT";
    ArticleRevisionState["PUBLISHED"] = "PUBLISHED";
    ArticleRevisionState["ARCHIVED"] = "ARCHIVED";
})(ArticleRevisionState || (ArticleRevisionState = {}));
var ArticleSort;
(function (ArticleSort) {
    ArticleSort["FIRST_PUBLISHED"] = "FIRST_PUBLISHED";
    ArticleSort["LAST_UPDATED"] = "LAST_UPDATED";
    ArticleSort["VIEW_COUNT"] = "VIEW_COUNT";
    ArticleSort["RELEVANCE"] = "RELEVANCE";
})(ArticleSort || (ArticleSort = {}));
var AssignActionReason;
(function (AssignActionReason) {
    AssignActionReason["CUSTOMER_PREFERENCE"] = "CUSTOMER_PREFERENCE";
    AssignActionReason["EXPERT_RECOMMENDATION"] = "EXPERT_RECOMMENDATION";
    AssignActionReason["MISSING_EXPERT_INFO"] = "MISSING_EXPERT_INFO";
    AssignActionReason["MERCHANT_UPDATE"] = "MERCHANT_UPDATE";
    AssignActionReason["NEED_MERCHANT_TRACKING"] = "NEED_MERCHANT_TRACKING";
    AssignActionReason["UPDATE_TRACKING"] = "UPDATE_TRACKING";
    AssignActionReason["CONFIRM_INVENTORY"] = "CONFIRM_INVENTORY";
    AssignActionReason["CLAIM_ITEM"] = "CLAIM_ITEM";
})(AssignActionReason || (AssignActionReason = {}));
var AttentionNeededLeadChangeType;
(function (AttentionNeededLeadChangeType) {
    AttentionNeededLeadChangeType["ADD"] = "ADD";
    AttentionNeededLeadChangeType["REMOVE"] = "REMOVE";
    AttentionNeededLeadChangeType["UPDATE"] = "UPDATE";
})(AttentionNeededLeadChangeType || (AttentionNeededLeadChangeType = {}));
var AttributedHtmlTextViewModelAttributeType;
(function (AttributedHtmlTextViewModelAttributeType) {
    AttributedHtmlTextViewModelAttributeType["IMAGE"] = "IMAGE";
})(AttributedHtmlTextViewModelAttributeType || (AttributedHtmlTextViewModelAttributeType = {}));
var AttributeFunction;
(function (AttributeFunction) {
    AttributeFunction["PRIMARY"] = "PRIMARY";
    AttributeFunction["SECONDARY"] = "SECONDARY";
    AttributeFunction["PERSONAL_INFORMATION"] = "PERSONAL_INFORMATION";
    AttributeFunction["ACCESSORY"] = "ACCESSORY";
    AttributeFunction["TAGGABLE"] = "TAGGABLE";
    AttributeFunction["SITEMAP_INDEXABLE"] = "SITEMAP_INDEXABLE";
    AttributeFunction["EXPERT_MATCHING"] = "EXPERT_MATCHING";
})(AttributeFunction || (AttributeFunction = {}));
var AttributeSchemaMetadataType;
(function (AttributeSchemaMetadataType) {
    AttributeSchemaMetadataType["GOOGLE_SHOPPING_FEED"] = "GOOGLE_SHOPPING_FEED";
    AttributeSchemaMetadataType["HIDDEN"] = "HIDDEN";
    AttributeSchemaMetadataType["SEARCH_FACET_NAME_ALIAS"] = "SEARCH_FACET_NAME_ALIAS";
    AttributeSchemaMetadataType["SEARCH_FACET_CAPPED_NUMERIC"] = "SEARCH_FACET_CAPPED_NUMERIC";
    AttributeSchemaMetadataType["SEARCH_FACET_DECIMAL_SCALE"] = "SEARCH_FACET_DECIMAL_SCALE";
    AttributeSchemaMetadataType["SEARCH_FACET_FIXED_INTEGER_BUCKET"] = "SEARCH_FACET_FIXED_INTEGER_BUCKET";
    AttributeSchemaMetadataType["SEARCH_FACET_HISTOGRAM_BUCKET"] = "SEARCH_FACET_HISTOGRAM_BUCKET";
    AttributeSchemaMetadataType["MISSING_ATTRIBUTE"] = "MISSING_ATTRIBUTE";
    AttributeSchemaMetadataType["EXPERT_NOTE"] = "EXPERT_NOTE";
})(AttributeSchemaMetadataType || (AttributeSchemaMetadataType = {}));
var AttributeSchemaRevisionQueryDraftFilter;
(function (AttributeSchemaRevisionQueryDraftFilter) {
    AttributeSchemaRevisionQueryDraftFilter["INCLUDE"] = "INCLUDE";
    AttributeSchemaRevisionQueryDraftFilter["INCLUDE_CREATED_DRAFT"] = "INCLUDE_CREATED_DRAFT";
    AttributeSchemaRevisionQueryDraftFilter["ONLY"] = "ONLY";
    AttributeSchemaRevisionQueryDraftFilter["NONE"] = "NONE";
})(AttributeSchemaRevisionQueryDraftFilter || (AttributeSchemaRevisionQueryDraftFilter = {}));
var AttributeSchemaRevisionSort;
(function (AttributeSchemaRevisionSort) {
    AttributeSchemaRevisionSort["NAME"] = "NAME";
    AttributeSchemaRevisionSort["CREATED_AT"] = "CREATED_AT";
    AttributeSchemaRevisionSort["KEYWORD_RELEVANCE"] = "KEYWORD_RELEVANCE";
})(AttributeSchemaRevisionSort || (AttributeSchemaRevisionSort = {}));
var AttributeSchemaRevisionState;
(function (AttributeSchemaRevisionState) {
    AttributeSchemaRevisionState["DRAFT"] = "DRAFT";
    AttributeSchemaRevisionState["PUBLISHED"] = "PUBLISHED";
    AttributeSchemaRevisionState["REPLACED"] = "REPLACED";
})(AttributeSchemaRevisionState || (AttributeSchemaRevisionState = {}));
var AttributeSearchFunction;
(function (AttributeSearchFunction) {
    AttributeSearchFunction["FACET"] = "FACET";
    AttributeSearchFunction["OVERRIDE_FACET_TYPE_AS_KEYWORD"] = "OVERRIDE_FACET_TYPE_AS_KEYWORD";
    AttributeSearchFunction["OVERRIDE_FACET_RAW_ATTRIBUTE_AS_KEYWORD"] = "OVERRIDE_FACET_RAW_ATTRIBUTE_AS_KEYWORD";
    AttributeSearchFunction["ORDER_FACET_TERMS_BY_LO_HI"] = "ORDER_FACET_TERMS_BY_LO_HI";
    AttributeSearchFunction["ORDER_FACET_TERMS_BY_LO_HI_AS_NUMERIC"] = "ORDER_FACET_TERMS_BY_LO_HI_AS_NUMERIC";
    AttributeSearchFunction["ORDER_FACET_TERMS_BY_HI_LO"] = "ORDER_FACET_TERMS_BY_HI_LO";
    AttributeSearchFunction["ORDER_FACET_TERMS_BY_ENUM_DEFINITION_ORDER"] = "ORDER_FACET_TERMS_BY_ENUM_DEFINITION_ORDER";
})(AttributeSearchFunction || (AttributeSearchFunction = {}));
var AttributeType;
(function (AttributeType) {
    AttributeType["INTEGER"] = "INTEGER";
    AttributeType["INTEGER_RANGE"] = "INTEGER_RANGE";
    AttributeType["DECIMAL"] = "DECIMAL";
    AttributeType["DECIMAL_RANGE"] = "DECIMAL_RANGE";
    AttributeType["TEXT"] = "TEXT";
    AttributeType["ENUMERATION"] = "ENUMERATION";
    AttributeType["LOCAL_DATE"] = "LOCAL_DATE";
    AttributeType["LOCAL_DATE_RANGE"] = "LOCAL_DATE_RANGE";
    AttributeType["LOCAL_TIME"] = "LOCAL_TIME";
    AttributeType["LOCAL_TIME_RANGE"] = "LOCAL_TIME_RANGE";
    AttributeType["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
    AttributeType["LOCAL_DATE_TIME_RANGE"] = "LOCAL_DATE_TIME_RANGE";
    AttributeType["ZONE_ID"] = "ZONE_ID";
    AttributeType["ID"] = "ID";
})(AttributeType || (AttributeType = {}));
var AttributeValidatorType;
(function (AttributeValidatorType) {
    AttributeValidatorType["CHARACTER_COUNT"] = "CHARACTER_COUNT";
    AttributeValidatorType["IN_RANGE_INTEGER"] = "IN_RANGE_INTEGER";
    AttributeValidatorType["IN_RANGE_DECIMAL"] = "IN_RANGE_DECIMAL";
    AttributeValidatorType["REGEX"] = "REGEX";
    AttributeValidatorType["CONTACT_AVAILABLE"] = "CONTACT_AVAILABLE";
    AttributeValidatorType["SMS_CAPABLE_PHONE_NUMBER"] = "SMS_CAPABLE_PHONE_NUMBER";
    AttributeValidatorType["VALID_EMAIL_ADDRESS"] = "VALID_EMAIL_ADDRESS";
    AttributeValidatorType["OAUTH_TOKEN_NOT_MAPPED"] = "OAUTH_TOKEN_NOT_MAPPED";
    AttributeValidatorType["ID_ENTITY_TYPE"] = "ID_ENTITY_TYPE";
})(AttributeValidatorType || (AttributeValidatorType = {}));
var AuthenticationMethod;
(function (AuthenticationMethod) {
    AuthenticationMethod["NO_PASSWORD"] = "NO_PASSWORD";
    AuthenticationMethod["PASSWORD"] = "PASSWORD";
    AuthenticationMethod["CHALLENGE"] = "CHALLENGE";
    AuthenticationMethod["LOGIN_TOKEN"] = "LOGIN_TOKEN";
    AuthenticationMethod["EXTERNAL_OAUTH"] = "EXTERNAL_OAUTH";
})(AuthenticationMethod || (AuthenticationMethod = {}));
var AuthenticationResult;
(function (AuthenticationResult) {
    AuthenticationResult["SUCCESS"] = "SUCCESS";
    AuthenticationResult["FAILURE"] = "FAILURE";
    AuthenticationResult["CHALLENGE"] = "CHALLENGE";
})(AuthenticationResult || (AuthenticationResult = {}));
var AwayAutoReplyStatus;
(function (AwayAutoReplyStatus) {
    AwayAutoReplyStatus["PENDING"] = "PENDING";
    AwayAutoReplyStatus["ACTIVE"] = "ACTIVE";
    AwayAutoReplyStatus["EXPIRED"] = "EXPIRED";
})(AwayAutoReplyStatus || (AwayAutoReplyStatus = {}));
var BookingSearchSort;
(function (BookingSearchSort) {
    BookingSearchSort["DEFAULT"] = "DEFAULT";
    BookingSearchSort["ORDER_CREATE_AT"] = "ORDER_CREATE_AT";
})(BookingSearchSort || (BookingSearchSort = {}));
var BookingState;
(function (BookingState) {
    BookingState["TRIP_COMPLETED"] = "TRIP_COMPLETED";
    BookingState["TRIP_UPCOMING"] = "TRIP_UPCOMING";
    BookingState["VERIFYING_PAYMENT"] = "VERIFYING_PAYMENT";
})(BookingState || (BookingState = {}));
var BroadcastOfferType;
(function (BroadcastOfferType) {
    BroadcastOfferType["PRODUCT"] = "PRODUCT";
    BroadcastOfferType["SERVICE"] = "SERVICE";
})(BroadcastOfferType || (BroadcastOfferType = {}));
var BusinessUserActivityType;
(function (BusinessUserActivityType) {
    BusinessUserActivityType["START_RECEIVING_LEADS"] = "START_RECEIVING_LEADS";
    BusinessUserActivityType["STOP_RECEIVING_LEADS"] = "STOP_RECEIVING_LEADS";
    BusinessUserActivityType["START_ON_CALL"] = "START_ON_CALL";
    BusinessUserActivityType["STOP_ON_CALL"] = "STOP_ON_CALL";
})(BusinessUserActivityType || (BusinessUserActivityType = {}));
var BusinessUserState;
(function (BusinessUserState) {
    BusinessUserState["ACTIVE"] = "ACTIVE";
    BusinessUserState["DEACTIVATING"] = "DEACTIVATING";
    BusinessUserState["DEACTIVATED"] = "DEACTIVATED";
    BusinessUserState["PENDING"] = "PENDING";
})(BusinessUserState || (BusinessUserState = {}));
var CallStatus;
(function (CallStatus) {
    CallStatus["QUEUED"] = "QUEUED";
    CallStatus["INITIATED"] = "INITIATED";
    CallStatus["RINGING"] = "RINGING";
    CallStatus["IN_PROGRESS"] = "IN_PROGRESS";
    CallStatus["COMPLETED"] = "COMPLETED";
    CallStatus["BUSY"] = "BUSY";
    CallStatus["NO_ANSWER"] = "NO_ANSWER";
    CallStatus["CANCELLED"] = "CANCELLED";
    CallStatus["FAILED"] = "FAILED";
    CallStatus["OTHER"] = "OTHER";
})(CallStatus || (CallStatus = {}));
var CallType;
(function (CallType) {
    CallType["EXPERT_TO_CONSUMER"] = "EXPERT_TO_CONSUMER";
    CallType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
})(CallType || (CallType = {}));
var CardFieldValidationStatus;
(function (CardFieldValidationStatus) {
    CardFieldValidationStatus["PASS"] = "PASS";
    CardFieldValidationStatus["FAIL"] = "FAIL";
    CardFieldValidationStatus["UNAVAILABLE"] = "UNAVAILABLE";
    CardFieldValidationStatus["UNCHECKED"] = "UNCHECKED";
})(CardFieldValidationStatus || (CardFieldValidationStatus = {}));
var CardFundingType;
(function (CardFundingType) {
    CardFundingType["UNKNOWN"] = "UNKNOWN";
    CardFundingType["CREDIT"] = "CREDIT";
    CardFundingType["DEBIT"] = "DEBIT";
    CardFundingType["PREPAID"] = "PREPAID";
})(CardFundingType || (CardFundingType = {}));
var CartSyncUseCase;
(function (CartSyncUseCase) {
    CartSyncUseCase["CART_VIEW"] = "CART_VIEW";
    CartSyncUseCase["CHECKOUT"] = "CHECKOUT";
})(CartSyncUseCase || (CartSyncUseCase = {}));
var CategoryType;
(function (CategoryType) {
    CategoryType["PRODUCT"] = "PRODUCT";
    CategoryType["SERVICE"] = "SERVICE";
})(CategoryType || (CategoryType = {}));
var ChallengeType;
(function (ChallengeType) {
    ChallengeType["OTP"] = "OTP";
    ChallengeType["PASSWORD"] = "PASSWORD";
})(ChallengeType || (ChallengeType = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["SMS"] = "SMS";
    ChannelType["INAPP"] = "INAPP";
    ChannelType["FACEBOOK"] = "FACEBOOK";
    ChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
    ChannelType["SLACK"] = "SLACK";
})(ChannelType || (ChannelType = {}));
var ClaimPromotionErrorCode;
(function (ClaimPromotionErrorCode) {
    ClaimPromotionErrorCode["NOT_FIRST_PURCHASE"] = "NOT_FIRST_PURCHASE";
    ClaimPromotionErrorCode["NO_PROMOTION_FOUND"] = "NO_PROMOTION_FOUND";
    ClaimPromotionErrorCode["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
    ClaimPromotionErrorCode["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
})(ClaimPromotionErrorCode || (ClaimPromotionErrorCode = {}));
var CloseTicketReason;
(function (CloseTicketReason) {
    CloseTicketReason["RESOLVED"] = "RESOLVED";
    CloseTicketReason["NO_ACTION_NEEDED"] = "NO_ACTION_NEEDED";
    CloseTicketReason["REQUESTER_DID_NOT_FOLLOWUP"] = "REQUESTER_DID_NOT_FOLLOWUP";
    CloseTicketReason["OPENED_NEW_TICKET"] = "OPENED_NEW_TICKET";
})(CloseTicketReason || (CloseTicketReason = {}));
var ConditionType;
(function (ConditionType) {
    ConditionType["ALWAYS_TRUE"] = "ALWAYS_TRUE";
    ConditionType["SUBJECT_ID_IN"] = "SUBJECT_ID_IN";
    ConditionType["STRING_BINARY"] = "STRING_BINARY";
    ConditionType["LOGICAL"] = "LOGICAL";
})(ConditionType || (ConditionType = {}));
var ConsumerInitialLeadAction;
(function (ConsumerInitialLeadAction) {
    ConsumerInitialLeadAction["BROWSE"] = "BROWSE";
    ConsumerInitialLeadAction["CHAT"] = "CHAT";
})(ConsumerInitialLeadAction || (ConsumerInitialLeadAction = {}));
var ConsumerReviewSearchSort;
(function (ConsumerReviewSearchSort) {
    ConsumerReviewSearchSort["RELEVANCE"] = "RELEVANCE";
    ConsumerReviewSearchSort["REVIEWED_AT"] = "REVIEWED_AT";
})(ConsumerReviewSearchSort || (ConsumerReviewSearchSort = {}));
var ConsumerReviewSource;
(function (ConsumerReviewSource) {
    ConsumerReviewSource["CURATED"] = "CURATED";
    ConsumerReviewSource["SHOPPER_APPROVED"] = "SHOPPER_APPROVED";
})(ConsumerReviewSource || (ConsumerReviewSource = {}));
var ConsumerSellableReactionRating;
(function (ConsumerSellableReactionRating) {
    ConsumerSellableReactionRating["SKIP"] = "SKIP";
    ConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
    ConsumerSellableReactionRating["LIKE"] = "LIKE";
    ConsumerSellableReactionRating["LOVE"] = "LOVE";
})(ConsumerSellableReactionRating || (ConsumerSellableReactionRating = {}));
var ConsumerSellableReactionReason;
(function (ConsumerSellableReactionReason) {
    ConsumerSellableReactionReason["PRICE"] = "PRICE";
    ConsumerSellableReactionReason["BRAND"] = "BRAND";
    ConsumerSellableReactionReason["STYLE"] = "STYLE";
    ConsumerSellableReactionReason["FEATURES"] = "FEATURES";
})(ConsumerSellableReactionReason || (ConsumerSellableReactionReason = {}));
var ConsumerSellableReactionSource;
(function (ConsumerSellableReactionSource) {
    ConsumerSellableReactionSource["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
    ConsumerSellableReactionSource["FAVORITES_PAGE"] = "FAVORITES_PAGE";
    ConsumerSellableReactionSource["SEARCH_RESULTS"] = "SEARCH_RESULTS";
    ConsumerSellableReactionSource["PRODUCT_DETAILS"] = "PRODUCT_DETAILS";
})(ConsumerSellableReactionSource || (ConsumerSellableReactionSource = {}));
var ContactType;
(function (ContactType) {
    ContactType["PHONE"] = "PHONE";
    ContactType["EMAIL"] = "EMAIL";
    ContactType["FACEBOOK"] = "FACEBOOK";
    ContactType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(ContactType || (ContactType = {}));
var ContentSelectionAdLevel;
(function (ContentSelectionAdLevel) {
    ContentSelectionAdLevel["NONE"] = "NONE";
    ContentSelectionAdLevel["AD"] = "AD";
    ContentSelectionAdLevel["AD_GROUP"] = "AD_GROUP";
    ContentSelectionAdLevel["CAMPAIGN"] = "CAMPAIGN";
    ContentSelectionAdLevel["SOURCE"] = "SOURCE";
})(ContentSelectionAdLevel || (ContentSelectionAdLevel = {}));
var ContentSelectionChannelType;
(function (ContentSelectionChannelType) {
    ContentSelectionChannelType["ENGAGEMENT_CHANNEL"] = "ENGAGEMENT_CHANNEL";
    ContentSelectionChannelType["LANDING_PAGE"] = "LANDING_PAGE";
    ContentSelectionChannelType["EXPERT_HIRING"] = "EXPERT_HIRING";
})(ContentSelectionChannelType || (ContentSelectionChannelType = {}));
var ContentSelectionDeviceType;
(function (ContentSelectionDeviceType) {
    ContentSelectionDeviceType["DESKTOP"] = "DESKTOP";
    ContentSelectionDeviceType["MOBILE_WEB"] = "MOBILE_WEB";
})(ContentSelectionDeviceType || (ContentSelectionDeviceType = {}));
var DatePathFlowQuestionType;
(function (DatePathFlowQuestionType) {
    DatePathFlowQuestionType["DATE"] = "DATE";
    DatePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DatePathFlowQuestionType || (DatePathFlowQuestionType = {}));
var DateRangeFilterField;
(function (DateRangeFilterField) {
    DateRangeFilterField["LAST_PAID_DATE"] = "LAST_PAID_DATE";
    DateRangeFilterField["CREATED_DATE"] = "CREATED_DATE";
    DateRangeFilterField["LAST_ACTIVITY_DATE"] = "LAST_ACTIVITY_DATE";
    DateRangeFilterField["ORDER_PAID_DATE"] = "ORDER_PAID_DATE";
    DateRangeFilterField["STARTED_DATE"] = "STARTED_DATE";
    DateRangeFilterField["COMPLETED_DATE"] = "COMPLETED_DATE";
    DateRangeFilterField["DUE_DATE"] = "DUE_DATE";
    DateRangeFilterField["LAST_MARKETING_EMAIL_SENT_DATE"] = "LAST_MARKETING_EMAIL_SENT_DATE";
    DateRangeFilterField["LAST_MARKETING_TEXT_SENT_DATE"] = "LAST_MARKETING_TEXT_SENT_DATE";
    DateRangeFilterField["LAST_MARKETING_CHAT_SENT_DATE"] = "LAST_MARKETING_CHAT_SENT_DATE";
    DateRangeFilterField["LAST_MARKETING_EMAIL_OPENED_DATE"] = "LAST_MARKETING_EMAIL_OPENED_DATE";
    DateRangeFilterField["LAST_MARKETING_EMAIL_CLICKED_DATE"] = "LAST_MARKETING_EMAIL_CLICKED_DATE";
    DateRangeFilterField["LAST_MARKETING_TEXT_CLICKED_DATE"] = "LAST_MARKETING_TEXT_CLICKED_DATE";
    DateRangeFilterField["LAST_MARKETING_CHAT_CLICKED_DATE"] = "LAST_MARKETING_CHAT_CLICKED_DATE";
    DateRangeFilterField["LAST_MARKETING_EMAIL_RESPONDED_DATE"] = "LAST_MARKETING_EMAIL_RESPONDED_DATE";
    DateRangeFilterField["LAST_MARKETING_TEXT_RESPONDED_DATE"] = "LAST_MARKETING_TEXT_RESPONDED_DATE";
    DateRangeFilterField["LAST_MARKETING_CHAT_RESPONDED_DATE"] = "LAST_MARKETING_CHAT_RESPONDED_DATE";
    DateRangeFilterField["LAST_MARKETING_ENGAGED_DATE"] = "LAST_MARKETING_ENGAGED_DATE";
})(DateRangeFilterField || (DateRangeFilterField = {}));
var DateRangePathFlowQuestionType;
(function (DateRangePathFlowQuestionType) {
    DateRangePathFlowQuestionType["DATE"] = "DATE";
    DateRangePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DateRangePathFlowQuestionType || (DateRangePathFlowQuestionType = {}));
var DealState;
(function (DealState) {
    DealState["ACTIVE"] = "ACTIVE";
    DealState["INACTIVE"] = "INACTIVE";
})(DealState || (DealState = {}));
var DealTermsType;
(function (DealTermsType) {
    DealTermsType["PRODUCT"] = "PRODUCT";
    DealTermsType["SERVICE"] = "SERVICE";
})(DealTermsType || (DealTermsType = {}));
var DepartmentNavigationLabelStyle;
(function (DepartmentNavigationLabelStyle) {
    DepartmentNavigationLabelStyle["BOLD"] = "BOLD";
})(DepartmentNavigationLabelStyle || (DepartmentNavigationLabelStyle = {}));
var DepartmentNavigationResponsiveFullSizeOptions;
(function (DepartmentNavigationResponsiveFullSizeOptions) {
    DepartmentNavigationResponsiveFullSizeOptions["SHOW"] = "SHOW";
})(DepartmentNavigationResponsiveFullSizeOptions || (DepartmentNavigationResponsiveFullSizeOptions = {}));
var DepartmentNavigationResponsiveSmallSizeOptions;
(function (DepartmentNavigationResponsiveSmallSizeOptions) {
    DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_PERSISTENT_HEADER"] = "SHOW_IN_PERSISTENT_HEADER";
    DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_FLYOUT_PANEL"] = "SHOW_IN_FLYOUT_PANEL";
})(DepartmentNavigationResponsiveSmallSizeOptions || (DepartmentNavigationResponsiveSmallSizeOptions = {}));
var DepartmentType;
(function (DepartmentType) {
    DepartmentType["CYCLING"] = "CYCLING";
    DepartmentType["CAMPING"] = "CAMPING";
    DepartmentType["CURATED_INTERNAL"] = "CURATED_INTERNAL";
    DepartmentType["FISHING"] = "FISHING";
    DepartmentType["GOLF"] = "GOLF";
    DepartmentType["JEWELRY"] = "JEWELRY";
    DepartmentType["JET_CHARTERS"] = "JET_CHARTERS";
    DepartmentType["OTHER"] = "OTHER";
    DepartmentType["WINTER_SPORTS"] = "WINTER_SPORTS";
    DepartmentType["YACHT_CHARTERS"] = "YACHT_CHARTERS";
})(DepartmentType || (DepartmentType = {}));
var DependencyUpdateType;
(function (DependencyUpdateType) {
    DependencyUpdateType["BLOCKED_BY"] = "BLOCKED_BY";
    DependencyUpdateType["UNBLOCKED_BY"] = "UNBLOCKED_BY";
})(DependencyUpdateType || (DependencyUpdateType = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["NANOS"] = "NANOS";
    DurationUnit["MILLIS"] = "MILLIS";
    DurationUnit["SECONDS"] = "SECONDS";
    DurationUnit["MINUTES"] = "MINUTES";
    DurationUnit["HOURS"] = "HOURS";
    DurationUnit["DAYS"] = "DAYS";
})(DurationUnit || (DurationUnit = {}));
var EditableUserSourceType;
(function (EditableUserSourceType) {
    EditableUserSourceType["ORGANIC"] = "ORGANIC";
    EditableUserSourceType["INVESTOR"] = "INVESTOR";
})(EditableUserSourceType || (EditableUserSourceType = {}));
var EmbedMediaType;
(function (EmbedMediaType) {
    EmbedMediaType["YOUTUBE"] = "YOUTUBE";
})(EmbedMediaType || (EmbedMediaType = {}));
var Environment;
(function (Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["STAGING"] = "STAGING";
    Environment["PRODUCTION"] = "PRODUCTION";
})(Environment || (Environment = {}));
var EscalationItemCondition;
(function (EscalationItemCondition) {
    EscalationItemCondition["NEW"] = "NEW";
    EscalationItemCondition["GOOD"] = "GOOD";
    EscalationItemCondition["OKAY"] = "OKAY";
})(EscalationItemCondition || (EscalationItemCondition = {}));
var EscalationResolution;
(function (EscalationResolution) {
    EscalationResolution["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    EscalationResolution["UNAVAILABLE_INVENTORY"] = "UNAVAILABLE_INVENTORY";
    EscalationResolution["REPLACEMENT_FOUND"] = "REPLACEMENT_FOUND";
})(EscalationResolution || (EscalationResolution = {}));
var ExperimentSortBy;
(function (ExperimentSortBy) {
    ExperimentSortBy["DEFAULT"] = "DEFAULT";
    ExperimentSortBy["NAME"] = "NAME";
    ExperimentSortBy["CREATED_AT"] = "CREATED_AT";
    ExperimentSortBy["UPDATED_AT"] = "UPDATED_AT";
})(ExperimentSortBy || (ExperimentSortBy = {}));
var ExperimentState;
(function (ExperimentState) {
    ExperimentState["ACTIVE"] = "ACTIVE";
    ExperimentState["ARCHIVED"] = "ARCHIVED";
})(ExperimentState || (ExperimentState = {}));
var ExpertApplicationFolderItemChangeType;
(function (ExpertApplicationFolderItemChangeType) {
    ExpertApplicationFolderItemChangeType["ADD"] = "ADD";
    ExpertApplicationFolderItemChangeType["REMOVE"] = "REMOVE";
    ExpertApplicationFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertApplicationFolderItemChangeType || (ExpertApplicationFolderItemChangeType = {}));
var ExpertApplicationFolderType;
(function (ExpertApplicationFolderType) {
    ExpertApplicationFolderType["PIPELINE"] = "PIPELINE";
    ExpertApplicationFolderType["FOLDERS"] = "FOLDERS";
})(ExpertApplicationFolderType || (ExpertApplicationFolderType = {}));
var ExpertApplicationRating;
(function (ExpertApplicationRating) {
    ExpertApplicationRating["YES"] = "YES";
    ExpertApplicationRating["NO"] = "NO";
})(ExpertApplicationRating || (ExpertApplicationRating = {}));
var ExpertApplicationSearchSort;
(function (ExpertApplicationSearchSort) {
    ExpertApplicationSearchSort["DEFAULT"] = "DEFAULT";
    ExpertApplicationSearchSort["APPLICATION_SUBMITTED_AT"] = "APPLICATION_SUBMITTED_AT";
})(ExpertApplicationSearchSort || (ExpertApplicationSearchSort = {}));
var ExpertApplicationState;
(function (ExpertApplicationState) {
    ExpertApplicationState["REJECTED"] = "REJECTED";
    ExpertApplicationState["ONBOARDED"] = "ONBOARDED";
    ExpertApplicationState["SCHEDULING"] = "SCHEDULING";
    ExpertApplicationState["FINAL_EVALUATION"] = "FINAL_EVALUATION";
    ExpertApplicationState["ONBOARDING"] = "ONBOARDING";
    ExpertApplicationState["APPROVED"] = "APPROVED";
    ExpertApplicationState["PENDING"] = "PENDING";
})(ExpertApplicationState || (ExpertApplicationState = {}));
var ExpertApplicationSubscriptionChangeType;
(function (ExpertApplicationSubscriptionChangeType) {
    ExpertApplicationSubscriptionChangeType["ADD"] = "ADD";
    ExpertApplicationSubscriptionChangeType["REMOVE"] = "REMOVE";
})(ExpertApplicationSubscriptionChangeType || (ExpertApplicationSubscriptionChangeType = {}));
var ExpertApplicationTaskState;
(function (ExpertApplicationTaskState) {
    ExpertApplicationTaskState["NOT_STARTED"] = "NOT_STARTED";
    ExpertApplicationTaskState["IN_PROGRESS"] = "IN_PROGRESS";
    ExpertApplicationTaskState["ERROR"] = "ERROR";
    ExpertApplicationTaskState["COMPLETED"] = "COMPLETED";
})(ExpertApplicationTaskState || (ExpertApplicationTaskState = {}));
var ExpertApplicationTaskType;
(function (ExpertApplicationTaskType) {
    ExpertApplicationTaskType["CALL_APPLICANT"] = "CALL_APPLICANT";
    ExpertApplicationTaskType["APPROVE_PROFILE"] = "APPROVE_PROFILE";
    ExpertApplicationTaskType["SIGN_CONTRACT"] = "SIGN_CONTRACT";
    ExpertApplicationTaskType["SETUP_PAYROLL"] = "SETUP_PAYROLL";
    ExpertApplicationTaskType["COMPLETE_TRAINING"] = "COMPLETE_TRAINING";
    ExpertApplicationTaskType["SETUP_7SHIFT"] = "SETUP_7SHIFT";
    ExpertApplicationTaskType["SETUP_SLACK"] = "SETUP_SLACK";
    ExpertApplicationTaskType["COMPLETE_HOMEWORK"] = "COMPLETE_HOMEWORK";
    ExpertApplicationTaskType["WAIT_FOR_SCHEDULING"] = "WAIT_FOR_SCHEDULING";
    ExpertApplicationTaskType["ADD_AVAILABILITY"] = "ADD_AVAILABILITY";
    ExpertApplicationTaskType["SCHEDULE_SHIFT"] = "SCHEDULE_SHIFT";
    ExpertApplicationTaskType["COMPLETE_FIRST_SHIFT"] = "COMPLETE_FIRST_SHIFT";
    ExpertApplicationTaskType["PASS_RESPONSIVE_EVAL"] = "PASS_RESPONSIVE_EVAL";
    ExpertApplicationTaskType["PASS_SKILL_EVAL"] = "PASS_SKILL_EVAL";
})(ExpertApplicationTaskType || (ExpertApplicationTaskType = {}));
var ExpertCuratedItemNoteSort;
(function (ExpertCuratedItemNoteSort) {
    ExpertCuratedItemNoteSort["USE_COUNT"] = "USE_COUNT";
    ExpertCuratedItemNoteSort["CREATED_AT"] = "CREATED_AT";
    ExpertCuratedItemNoteSort["UPDATED_AT"] = "UPDATED_AT";
})(ExpertCuratedItemNoteSort || (ExpertCuratedItemNoteSort = {}));
var ExpertCuratedItemNoteState;
(function (ExpertCuratedItemNoteState) {
    ExpertCuratedItemNoteState["NONE"] = "NONE";
    ExpertCuratedItemNoteState["DRAFT"] = "DRAFT";
    ExpertCuratedItemNoteState["PENDING"] = "PENDING";
    ExpertCuratedItemNoteState["APPROVED"] = "APPROVED";
    ExpertCuratedItemNoteState["REJECTED"] = "REJECTED";
    ExpertCuratedItemNoteState["ARCHIVED"] = "ARCHIVED";
})(ExpertCuratedItemNoteState || (ExpertCuratedItemNoteState = {}));
var ExpertCuratedItemPriceOverrideReasonType;
(function (ExpertCuratedItemPriceOverrideReasonType) {
    ExpertCuratedItemPriceOverrideReasonType["PRICE_MATCH"] = "PRICE_MATCH";
    ExpertCuratedItemPriceOverrideReasonType["SPECIAL_DISCOUNT"] = "SPECIAL_DISCOUNT";
    ExpertCuratedItemPriceOverrideReasonType["OTHER"] = "OTHER";
    ExpertCuratedItemPriceOverrideReasonType["SECRET_DEAL"] = "SECRET_DEAL";
})(ExpertCuratedItemPriceOverrideReasonType || (ExpertCuratedItemPriceOverrideReasonType = {}));
var ExpertCuratedItemRankChangeType;
(function (ExpertCuratedItemRankChangeType) {
    ExpertCuratedItemRankChangeType["INCREMENT"] = "INCREMENT";
    ExpertCuratedItemRankChangeType["DECREMENT"] = "DECREMENT";
})(ExpertCuratedItemRankChangeType || (ExpertCuratedItemRankChangeType = {}));
var ExpertCuratedItemRemovedReason;
(function (ExpertCuratedItemRemovedReason) {
    ExpertCuratedItemRemovedReason["REPLACED"] = "REPLACED";
    ExpertCuratedItemRemovedReason["REMOVED_BY_EXPERT"] = "REMOVED_BY_EXPERT";
    ExpertCuratedItemRemovedReason["NOT_INTERESTED"] = "NOT_INTERESTED";
    ExpertCuratedItemRemovedReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
    ExpertCuratedItemRemovedReason["LOW_QUALITY"] = "LOW_QUALITY";
    ExpertCuratedItemRemovedReason["UGLY"] = "UGLY";
    ExpertCuratedItemRemovedReason["DONT_NEED"] = "DONT_NEED";
    ExpertCuratedItemRemovedReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
    ExpertCuratedItemRemovedReason["OTHER"] = "OTHER";
})(ExpertCuratedItemRemovedReason || (ExpertCuratedItemRemovedReason = {}));
var ExpertCuratedItemSort;
(function (ExpertCuratedItemSort) {
    ExpertCuratedItemSort["DEFAULT"] = "DEFAULT";
    ExpertCuratedItemSort["CREATED_AT"] = "CREATED_AT";
})(ExpertCuratedItemSort || (ExpertCuratedItemSort = {}));
var ExpertCuratedItemStateFilter;
(function (ExpertCuratedItemStateFilter) {
    ExpertCuratedItemStateFilter["DRAFT"] = "DRAFT";
    ExpertCuratedItemStateFilter["ACTIVE"] = "ACTIVE";
    ExpertCuratedItemStateFilter["REMOVED"] = "REMOVED";
    ExpertCuratedItemStateFilter["NOT_REMOVED"] = "NOT_REMOVED";
})(ExpertCuratedItemStateFilter || (ExpertCuratedItemStateFilter = {}));
var ExpertCuratedItemTagType;
(function (ExpertCuratedItemTagType) {
    ExpertCuratedItemTagType["SPECIAL_OFFER"] = "SPECIAL_OFFER";
    ExpertCuratedItemTagType["THE_ALTERNATIVE"] = "THE_ALTERNATIVE";
    ExpertCuratedItemTagType["SALE_PRICE"] = "SALE_PRICE";
    ExpertCuratedItemTagType["EXPERT_PICK"] = "EXPERT_PICK";
    ExpertCuratedItemTagType["BUDGET_PICK"] = "BUDGET_PICK";
    ExpertCuratedItemTagType["CUSTOM"] = "CUSTOM";
    ExpertCuratedItemTagType["OTHER"] = "OTHER";
})(ExpertCuratedItemTagType || (ExpertCuratedItemTagType = {}));
var ExpertCuratedOrderClosedReason;
(function (ExpertCuratedOrderClosedReason) {
    ExpertCuratedOrderClosedReason["MANUAL"] = "MANUAL";
    ExpertCuratedOrderClosedReason["REPLACED"] = "REPLACED";
})(ExpertCuratedOrderClosedReason || (ExpertCuratedOrderClosedReason = {}));
var ExpertCuratedOrderSelectErrorCode;
(function (ExpertCuratedOrderSelectErrorCode) {
    ExpertCuratedOrderSelectErrorCode["NOT_ACTIVE"] = "NOT_ACTIVE";
})(ExpertCuratedOrderSelectErrorCode || (ExpertCuratedOrderSelectErrorCode = {}));
var ExpertCuratedOrderServiceLocationErrorCode;
(function (ExpertCuratedOrderServiceLocationErrorCode) {
    ExpertCuratedOrderServiceLocationErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
})(ExpertCuratedOrderServiceLocationErrorCode || (ExpertCuratedOrderServiceLocationErrorCode = {}));
var ExpertCuratedOrdersForLeadQueryCustomFilter;
(function (ExpertCuratedOrdersForLeadQueryCustomFilter) {
    ExpertCuratedOrdersForLeadQueryCustomFilter["INCLUDE"] = "INCLUDE";
    ExpertCuratedOrdersForLeadQueryCustomFilter["ONLY"] = "ONLY";
    ExpertCuratedOrdersForLeadQueryCustomFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryCustomFilter || (ExpertCuratedOrdersForLeadQueryCustomFilter = {}));
var ExpertCuratedOrdersForLeadQueryDraftFilter;
(function (ExpertCuratedOrdersForLeadQueryDraftFilter) {
    ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE"] = "INCLUDE";
    ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE_CREATED_DRAFT"] = "INCLUDE_CREATED_DRAFT";
    ExpertCuratedOrdersForLeadQueryDraftFilter["ONLY"] = "ONLY";
    ExpertCuratedOrdersForLeadQueryDraftFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryDraftFilter || (ExpertCuratedOrdersForLeadQueryDraftFilter = {}));
var ExpertCuratedOrderState;
(function (ExpertCuratedOrderState) {
    ExpertCuratedOrderState["DRAFT"] = "DRAFT";
    ExpertCuratedOrderState["ACTIVE"] = "ACTIVE";
    ExpertCuratedOrderState["CLOSED"] = "CLOSED";
    ExpertCuratedOrderState["EXPIRED"] = "EXPIRED";
})(ExpertCuratedOrderState || (ExpertCuratedOrderState = {}));
var ExpertGender;
(function (ExpertGender) {
    ExpertGender["MALE"] = "MALE";
    ExpertGender["FEMALE"] = "FEMALE";
    ExpertGender["OTHER"] = "OTHER";
})(ExpertGender || (ExpertGender = {}));
var ExpertHiringFeedbackState;
(function (ExpertHiringFeedbackState) {
    ExpertHiringFeedbackState["DRAFT"] = "DRAFT";
    ExpertHiringFeedbackState["SUBMITTED"] = "SUBMITTED";
})(ExpertHiringFeedbackState || (ExpertHiringFeedbackState = {}));
var ExpertHiringFeedbackType;
(function (ExpertHiringFeedbackType) {
    ExpertHiringFeedbackType["INTERVIEW_FEEDBACK"] = "INTERVIEW_FEEDBACK";
    ExpertHiringFeedbackType["APPLICATION_EVALUATION"] = "APPLICATION_EVALUATION";
    ExpertHiringFeedbackType["APPLICATION_RATING"] = "APPLICATION_RATING";
})(ExpertHiringFeedbackType || (ExpertHiringFeedbackType = {}));
var ExpertLeadFolderGroupType;
(function (ExpertLeadFolderGroupType) {
    ExpertLeadFolderGroupType["INBOX"] = "INBOX";
    ExpertLeadFolderGroupType["INBOX_ASSISTANT"] = "INBOX_ASSISTANT";
    ExpertLeadFolderGroupType["SALES_PIPELINE"] = "SALES_PIPELINE";
    ExpertLeadFolderGroupType["FOLDERS"] = "FOLDERS";
})(ExpertLeadFolderGroupType || (ExpertLeadFolderGroupType = {}));
var ExpertLeadFolderItemChangeType;
(function (ExpertLeadFolderItemChangeType) {
    ExpertLeadFolderItemChangeType["ADD"] = "ADD";
    ExpertLeadFolderItemChangeType["REMOVE"] = "REMOVE";
    ExpertLeadFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertLeadFolderItemChangeType || (ExpertLeadFolderItemChangeType = {}));
var ExpertNoteVisibilityType;
(function (ExpertNoteVisibilityType) {
    ExpertNoteVisibilityType["PUBLIC"] = "PUBLIC";
    ExpertNoteVisibilityType["PRIVATE"] = "PRIVATE";
})(ExpertNoteVisibilityType || (ExpertNoteVisibilityType = {}));
var ExpertNotificationMode;
(function (ExpertNotificationMode) {
    ExpertNotificationMode["NONE"] = "NONE";
    ExpertNotificationMode["ALWAYS"] = "ALWAYS";
    ExpertNotificationMode["WHEN_NOT_ACTIVATED"] = "WHEN_NOT_ACTIVATED";
    ExpertNotificationMode["WHEN_NOT_ONLINE"] = "WHEN_NOT_ONLINE";
})(ExpertNotificationMode || (ExpertNotificationMode = {}));
var ExpertNotificationType;
(function (ExpertNotificationType) {
    ExpertNotificationType["LEAD_ESCALATION"] = "LEAD_ESCALATION";
    ExpertNotificationType["PRESENCE_STATUS_CHANGE"] = "PRESENCE_STATUS_CHANGE";
    ExpertNotificationType["SHIFT_ENDED"] = "SHIFT_ENDED";
    ExpertNotificationType["LEAD_SURGE"] = "LEAD_SURGE";
})(ExpertNotificationType || (ExpertNotificationType = {}));
var ExpertPerformanceRating;
(function (ExpertPerformanceRating) {
    ExpertPerformanceRating["NEW"] = "NEW";
    ExpertPerformanceRating["MASTER"] = "MASTER";
    ExpertPerformanceRating["DIAMOND"] = "DIAMOND";
    ExpertPerformanceRating["PLATINUM"] = "PLATINUM";
    ExpertPerformanceRating["GOLD"] = "GOLD";
    ExpertPerformanceRating["SILVER"] = "SILVER";
    ExpertPerformanceRating["BRONZE"] = "BRONZE";
})(ExpertPerformanceRating || (ExpertPerformanceRating = {}));
var ExpertPresenceStatus;
(function (ExpertPresenceStatus) {
    ExpertPresenceStatus["OFF_SHIFT"] = "OFF_SHIFT";
    ExpertPresenceStatus["ON_SHIFT"] = "ON_SHIFT";
    ExpertPresenceStatus["ON_CALL"] = "ON_CALL";
    ExpertPresenceStatus["AWAY"] = "AWAY";
})(ExpertPresenceStatus || (ExpertPresenceStatus = {}));
var ExpertProfileState;
(function (ExpertProfileState) {
    ExpertProfileState["DRAFT"] = "DRAFT";
    ExpertProfileState["SUBMITTED"] = "SUBMITTED";
    ExpertProfileState["PUBLISHED"] = "PUBLISHED";
})(ExpertProfileState || (ExpertProfileState = {}));
var ExpertRecommendationStrategy;
(function (ExpertRecommendationStrategy) {
    ExpertRecommendationStrategy["LEAST_WORKLOAD"] = "LEAST_WORKLOAD";
    ExpertRecommendationStrategy["PERFORMANCE_WEIGHTED"] = "PERFORMANCE_WEIGHTED";
    ExpertRecommendationStrategy["ASSISTANT_FIRST"] = "ASSISTANT_FIRST";
})(ExpertRecommendationStrategy || (ExpertRecommendationStrategy = {}));
var ExpertSearchSort;
(function (ExpertSearchSort) {
    ExpertSearchSort["DEFAULT"] = "DEFAULT";
    ExpertSearchSort["PERFORMANCE"] = "PERFORMANCE";
    ExpertSearchSort["FEATURED"] = "FEATURED";
})(ExpertSearchSort || (ExpertSearchSort = {}));
var ExternalAdPlatform;
(function (ExternalAdPlatform) {
    ExternalAdPlatform["FACEBOOK"] = "FACEBOOK";
    ExternalAdPlatform["GOOGLE"] = "GOOGLE";
})(ExternalAdPlatform || (ExternalAdPlatform = {}));
var ExternalAdStatus;
(function (ExternalAdStatus) {
    ExternalAdStatus["ACTIVE"] = "ACTIVE";
    ExternalAdStatus["PAUSED"] = "PAUSED";
    ExternalAdStatus["DELETED"] = "DELETED";
})(ExternalAdStatus || (ExternalAdStatus = {}));
var ExternalInventoryItemSourceType;
(function (ExternalInventoryItemSourceType) {
    ExternalInventoryItemSourceType["SHOPIFY"] = "SHOPIFY";
})(ExternalInventoryItemSourceType || (ExternalInventoryItemSourceType = {}));
var ExternalProfileType;
(function (ExternalProfileType) {
    ExternalProfileType["FACEBOOK_MESSENGER"] = "FACEBOOK_MESSENGER";
    ExternalProfileType["PIPL"] = "PIPL";
})(ExternalProfileType || (ExternalProfileType = {}));
var ExternalVideoIdType;
(function (ExternalVideoIdType) {
    ExternalVideoIdType["YOUTUBE"] = "YOUTUBE";
    ExternalVideoIdType["VIMEO"] = "VIMEO";
})(ExternalVideoIdType || (ExternalVideoIdType = {}));
var FacetImageType;
(function (FacetImageType) {
    FacetImageType["ICON"] = "ICON";
    FacetImageType["BACKGROUND"] = "BACKGROUND";
})(FacetImageType || (FacetImageType = {}));
var FlightPlanEditErrorCode;
(function (FlightPlanEditErrorCode) {
    FlightPlanEditErrorCode["EMPTY_LEGS"] = "EMPTY_LEGS";
    FlightPlanEditErrorCode["NO_SUCH_LEG"] = "NO_SUCH_LEG";
    FlightPlanEditErrorCode["MISSING_AIRPORT"] = "MISSING_AIRPORT";
    FlightPlanEditErrorCode["SAME_AIRPORT"] = "SAME_AIRPORT";
    FlightPlanEditErrorCode["OVERLAPPING_LEGS"] = "OVERLAPPING_LEGS";
    FlightPlanEditErrorCode["NOT_DRAFT"] = "NOT_DRAFT";
})(FlightPlanEditErrorCode || (FlightPlanEditErrorCode = {}));
var FlightPlanState;
(function (FlightPlanState) {
    FlightPlanState["DRAFT"] = "DRAFT";
    FlightPlanState["ACTIVE"] = "ACTIVE";
})(FlightPlanState || (FlightPlanState = {}));
var FrontendTaskStatus;
(function (FrontendTaskStatus) {
    FrontendTaskStatus["CREATED"] = "CREATED";
    FrontendTaskStatus["PROCESSING"] = "PROCESSING";
    FrontendTaskStatus["COMPLETED"] = "COMPLETED";
    FrontendTaskStatus["ABORTED"] = "ABORTED";
})(FrontendTaskStatus || (FrontendTaskStatus = {}));
var FulfillmentChannelType;
(function (FulfillmentChannelType) {
    FulfillmentChannelType["WAREHOUSE"] = "WAREHOUSE";
    FulfillmentChannelType["MANUFACTURER"] = "MANUFACTURER";
    FulfillmentChannelType["RETAILER"] = "RETAILER";
    FulfillmentChannelType["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
    FulfillmentChannelType["AD_HOC"] = "AD_HOC";
    FulfillmentChannelType["OFFLINE_PARTNERS"] = "OFFLINE_PARTNERS";
})(FulfillmentChannelType || (FulfillmentChannelType = {}));
var FulfillmentOrderDeliveryStatus;
(function (FulfillmentOrderDeliveryStatus) {
    FulfillmentOrderDeliveryStatus["ATTEMPTED_DELIVERY"] = "ATTEMPTED_DELIVERY";
    FulfillmentOrderDeliveryStatus["CANCELED"] = "CANCELED";
    FulfillmentOrderDeliveryStatus["CONFIRMED"] = "CONFIRMED";
    FulfillmentOrderDeliveryStatus["DELIVERED"] = "DELIVERED";
    FulfillmentOrderDeliveryStatus["FAILURE"] = "FAILURE";
    FulfillmentOrderDeliveryStatus["FULFILLED"] = "FULFILLED";
    FulfillmentOrderDeliveryStatus["IN_TRANSIT"] = "IN_TRANSIT";
    FulfillmentOrderDeliveryStatus["LABEL_PRINTED"] = "LABEL_PRINTED";
    FulfillmentOrderDeliveryStatus["LABEL_PURCHASED"] = "LABEL_PURCHASED";
    FulfillmentOrderDeliveryStatus["LABEL_VOIDED"] = "LABEL_VOIDED";
    FulfillmentOrderDeliveryStatus["MARKED_AS_FULFILLED"] = "MARKED_AS_FULFILLED";
    FulfillmentOrderDeliveryStatus["NOT_DELIVERED"] = "NOT_DELIVERED";
    FulfillmentOrderDeliveryStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
    FulfillmentOrderDeliveryStatus["READY_FOR_PICKUP"] = "READY_FOR_PICKUP";
    FulfillmentOrderDeliveryStatus["SUBMITTED"] = "SUBMITTED";
})(FulfillmentOrderDeliveryStatus || (FulfillmentOrderDeliveryStatus = {}));
var FulfillmentOrderSourceType;
(function (FulfillmentOrderSourceType) {
    FulfillmentOrderSourceType["DEAL"] = "DEAL";
    FulfillmentOrderSourceType["SHOPIFY"] = "SHOPIFY";
    FulfillmentOrderSourceType["EXTERNAL_PARTNER"] = "EXTERNAL_PARTNER";
})(FulfillmentOrderSourceType || (FulfillmentOrderSourceType = {}));
var FulfillmentServiceProvider;
(function (FulfillmentServiceProvider) {
    FulfillmentServiceProvider["DEAL"] = "DEAL";
    FulfillmentServiceProvider["UPS"] = "UPS";
})(FulfillmentServiceProvider || (FulfillmentServiceProvider = {}));
var FulfillmentServiceType;
(function (FulfillmentServiceType) {
    FulfillmentServiceType["THIRD_PARTY_LOGISTICS"] = "THIRD_PARTY_LOGISTICS";
    FulfillmentServiceType["DEAL_WH"] = "DEAL_WH";
})(FulfillmentServiceType || (FulfillmentServiceType = {}));
var FulfillmentStatus;
(function (FulfillmentStatus) {
    FulfillmentStatus["REQUESTED"] = "REQUESTED";
    FulfillmentStatus["CANCELLED"] = "CANCELLED";
    FulfillmentStatus["ERROR"] = "ERROR";
    FulfillmentStatus["FAILED"] = "FAILED";
    FulfillmentStatus["PROCESSING"] = "PROCESSING";
    FulfillmentStatus["PENDING"] = "PENDING";
    FulfillmentStatus["PARTIAL"] = "PARTIAL";
    FulfillmentStatus["COMPLETED"] = "COMPLETED";
})(FulfillmentStatus || (FulfillmentStatus = {}));
var FulfillmentSuggestionStatus;
(function (FulfillmentSuggestionStatus) {
    FulfillmentSuggestionStatus["PENDING"] = "PENDING";
    FulfillmentSuggestionStatus["FULFILLED"] = "FULFILLED";
    FulfillmentSuggestionStatus["SKIPPED"] = "SKIPPED";
    FulfillmentSuggestionStatus["UNAVAILABLE"] = "UNAVAILABLE";
    FulfillmentSuggestionStatus["PRICE_TOO_HIGH"] = "PRICE_TOO_HIGH";
    FulfillmentSuggestionStatus["SHIPPING_TOO_SLOW"] = "SHIPPING_TOO_SLOW";
    FulfillmentSuggestionStatus["FAILED"] = "FAILED";
})(FulfillmentSuggestionStatus || (FulfillmentSuggestionStatus = {}));
var GuestConversationSequenceState;
(function (GuestConversationSequenceState) {
    GuestConversationSequenceState["DRAFT"] = "DRAFT";
    GuestConversationSequenceState["ACTIVE"] = "ACTIVE";
    GuestConversationSequenceState["INACTIVE"] = "INACTIVE";
})(GuestConversationSequenceState || (GuestConversationSequenceState = {}));
var HandleType;
(function (HandleType) {
    HandleType["EMAIL"] = "EMAIL";
    HandleType["PHONE"] = "PHONE";
})(HandleType || (HandleType = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["GUEST"] = "GUEST";
    IdentityType["USER"] = "USER";
    IdentityType["BUSINESS_USER"] = "BUSINESS_USER";
    IdentityType["OPERATOR"] = "OPERATOR";
    IdentityType["SYSTEM_USER"] = "SYSTEM_USER";
    IdentityType["IMPORTED_IDENTITY"] = "IMPORTED_IDENTITY";
})(IdentityType || (IdentityType = {}));
var IdPathFlowQuestionType;
(function (IdPathFlowQuestionType) {
    IdPathFlowQuestionType["MEDIA_ID_IMAGE_UPLOAD"] = "MEDIA_ID_IMAGE_UPLOAD";
    IdPathFlowQuestionType["EXPERT_ID_SELECTION"] = "EXPERT_ID_SELECTION";
    IdPathFlowQuestionType["PRODUCTS_TYPEAHEAD"] = "PRODUCTS_TYPEAHEAD";
    IdPathFlowQuestionType["FLIGHT_PLAN"] = "FLIGHT_PLAN";
})(IdPathFlowQuestionType || (IdPathFlowQuestionType = {}));
var InputTextPathFlowQuestionFieldType;
(function (InputTextPathFlowQuestionFieldType) {
    InputTextPathFlowQuestionFieldType["AIRPORT_TYPEAHEAD"] = "AIRPORT_TYPEAHEAD";
    InputTextPathFlowQuestionFieldType["SMS_TEXT"] = "SMS_TEXT";
    InputTextPathFlowQuestionFieldType["FACEBOOK_USER_REF"] = "FACEBOOK_USER_REF";
    InputTextPathFlowQuestionFieldType["FCM_TOKEN"] = "FCM_TOKEN";
    InputTextPathFlowQuestionFieldType["INPUT_FIELD"] = "INPUT_FIELD";
    InputTextPathFlowQuestionFieldType["TEXT_AREA"] = "TEXT_AREA";
    InputTextPathFlowQuestionFieldType["NUMERIC"] = "NUMERIC";
    InputTextPathFlowQuestionFieldType["TELEPHONE"] = "TELEPHONE";
    InputTextPathFlowQuestionFieldType["TELEPHONE_SUBMIT"] = "TELEPHONE_SUBMIT";
    InputTextPathFlowQuestionFieldType["EMAIL"] = "EMAIL";
    InputTextPathFlowQuestionFieldType["HIDDEN"] = "HIDDEN";
})(InputTextPathFlowQuestionFieldType || (InputTextPathFlowQuestionFieldType = {}));
var InputTextPathFlowQuestionValidationType;
(function (InputTextPathFlowQuestionValidationType) {
    InputTextPathFlowQuestionValidationType["LENGTH"] = "LENGTH";
    InputTextPathFlowQuestionValidationType["REGEX"] = "REGEX";
    InputTextPathFlowQuestionValidationType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(InputTextPathFlowQuestionValidationType || (InputTextPathFlowQuestionValidationType = {}));
var InterstitialPathFlowPageMetadataType;
(function (InterstitialPathFlowPageMetadataType) {
    InterstitialPathFlowPageMetadataType["ALMOST_DONE"] = "ALMOST_DONE";
    InterstitialPathFlowPageMetadataType["BROWSE_EXPERTS"] = "BROWSE_EXPERTS";
    InterstitialPathFlowPageMetadataType["CALCULATING"] = "CALCULATING";
    InterstitialPathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
    InterstitialPathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
    InterstitialPathFlowPageMetadataType["GENERIC_WITH_BUTTON"] = "GENERIC_WITH_BUTTON";
    InterstitialPathFlowPageMetadataType["GENERIC_WITH_TITLE"] = "GENERIC_WITH_TITLE";
    InterstitialPathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
    InterstitialPathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
    InterstitialPathFlowPageMetadataType["SNOWBOARD_INT_LEARN"] = "SNOWBOARD_INT_LEARN";
    InterstitialPathFlowPageMetadataType["WELCOME"] = "WELCOME";
    InterstitialPathFlowPageMetadataType["GIVE_US_A_SEC"] = "GIVE_US_A_SEC";
    InterstitialPathFlowPageMetadataType["REQUEST_PUSH_NOTIFICATION_PERMISSION"] = "REQUEST_PUSH_NOTIFICATION_PERMISSION";
    InterstitialPathFlowPageMetadataType["WHAT_HAPPENS_NEXT"] = "WHAT_HAPPENS_NEXT";
})(InterstitialPathFlowPageMetadataType || (InterstitialPathFlowPageMetadataType = {}));
var LeadActivityType;
(function (LeadActivityType) {
    LeadActivityType["DELEGATE_EXPERT_CHANGED"] = "DELEGATE_EXPERT_CHANGED";
    LeadActivityType["SNOOZE_CHANGED"] = "SNOOZE_CHANGED";
    LeadActivityType["WOKE_UP_FROM_SNOOZE"] = "WOKE_UP_FROM_SNOOZE";
    LeadActivityType["REASSIGNED"] = "REASSIGNED";
    LeadActivityType["ARCHIVED"] = "ARCHIVED";
    LeadActivityType["CONSUMER_FIRST_MESSAGE_SENT"] = "CONSUMER_FIRST_MESSAGE_SENT";
    LeadActivityType["CONSUMER_CALLED"] = "CONSUMER_CALLED";
    LeadActivityType["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
    LeadActivityType["CONSUMER_PAYMENT_SUCCEEDED"] = "CONSUMER_PAYMENT_SUCCEEDED";
    LeadActivityType["CONSUMER_ORDER_PAID"] = "CONSUMER_ORDER_PAID";
    LeadActivityType["CONSUMER_REVIEW_ADDED"] = "CONSUMER_REVIEW_ADDED";
    LeadActivityType["ESCALATION_STARTED"] = "ESCALATION_STARTED";
    LeadActivityType["ESCALATION_CHANGED"] = "ESCALATION_CHANGED";
    LeadActivityType["QUALITY_CONVERSATION_ESTABLISHED"] = "QUALITY_CONVERSATION_ESTABLISHED";
    LeadActivityType["LEAD_CREATED"] = "LEAD_CREATED";
    LeadActivityType["STOP_REQUESTED"] = "STOP_REQUESTED";
})(LeadActivityType || (LeadActivityType = {}));
var LeadCampaignRecipientSortOrder;
(function (LeadCampaignRecipientSortOrder) {
    LeadCampaignRecipientSortOrder["MOST_RECENT_ACTIVITY"] = "MOST_RECENT_ACTIVITY";
    LeadCampaignRecipientSortOrder["RANDOM"] = "RANDOM";
})(LeadCampaignRecipientSortOrder || (LeadCampaignRecipientSortOrder = {}));
var LeadCampaignState;
(function (LeadCampaignState) {
    LeadCampaignState["DRAFT"] = "DRAFT";
    LeadCampaignState["PREPARING"] = "PREPARING";
    LeadCampaignState["PUBLISHED"] = "PUBLISHED";
    LeadCampaignState["DELIVERING"] = "DELIVERING";
    LeadCampaignState["DEACTIVATED"] = "DEACTIVATED";
})(LeadCampaignState || (LeadCampaignState = {}));
var LeadCampaignTriggerExecutionInterval;
(function (LeadCampaignTriggerExecutionInterval) {
    LeadCampaignTriggerExecutionInterval["EMAIL"] = "EMAIL";
    LeadCampaignTriggerExecutionInterval["SMS_LONG_CODE"] = "SMS_LONG_CODE";
    LeadCampaignTriggerExecutionInterval["SMS_SHORT_CODE"] = "SMS_SHORT_CODE";
})(LeadCampaignTriggerExecutionInterval || (LeadCampaignTriggerExecutionInterval = {}));
var LeadEscalationLevel;
(function (LeadEscalationLevel) {
    LeadEscalationLevel["NOT_STARTED"] = "NOT_STARTED";
    LeadEscalationLevel["ONLINE_TEAM_MEMBERS"] = "ONLINE_TEAM_MEMBERS";
    LeadEscalationLevel["ALL_TEAM_MEMBERS"] = "ALL_TEAM_MEMBERS";
    LeadEscalationLevel["SUPPORT"] = "SUPPORT";
    LeadEscalationLevel["ONLINE_EXPERTS"] = "ONLINE_EXPERTS";
    LeadEscalationLevel["ALL_EXPERTS"] = "ALL_EXPERTS";
    LeadEscalationLevel["ON_CALL_EXPERTS"] = "ON_CALL_EXPERTS";
})(LeadEscalationLevel || (LeadEscalationLevel = {}));
var LeadEscalationStatus;
(function (LeadEscalationStatus) {
    LeadEscalationStatus["OPEN"] = "OPEN";
    LeadEscalationStatus["CLOSED"] = "CLOSED";
})(LeadEscalationStatus || (LeadEscalationStatus = {}));
var LeadEscalationType;
(function (LeadEscalationType) {
    LeadEscalationType["CONSUMER_WAITING_RESPONSE"] = "CONSUMER_WAITING_RESPONSE";
})(LeadEscalationType || (LeadEscalationType = {}));
var LeadExpertRole;
(function (LeadExpertRole) {
    LeadExpertRole["PRIMARY"] = "PRIMARY";
    LeadExpertRole["DELEGATE"] = "DELEGATE";
})(LeadExpertRole || (LeadExpertRole = {}));
var LeadIntentLabel;
(function (LeadIntentLabel) {
    LeadIntentLabel["HIGH_INTENT_FOR_CONVERSION"] = "HIGH_INTENT_FOR_CONVERSION";
})(LeadIntentLabel || (LeadIntentLabel = {}));
var LeadParticipantType;
(function (LeadParticipantType) {
    LeadParticipantType["EXPERT"] = "EXPERT";
    LeadParticipantType["DELEGATE_EXPERT"] = "DELEGATE_EXPERT";
    LeadParticipantType["CONSUMER"] = "CONSUMER";
    LeadParticipantType["ASSISTANT"] = "ASSISTANT";
    LeadParticipantType["DEAL_BOT"] = "DEAL_BOT";
})(LeadParticipantType || (LeadParticipantType = {}));
var LeadReassignmentReason;
(function (LeadReassignmentReason) {
    LeadReassignmentReason["EXPERT_DEACTIVATED"] = "EXPERT_DEACTIVATED";
    LeadReassignmentReason["ORDER_SUPPORT_ACTION"] = "ORDER_SUPPORT_ACTION";
    LeadReassignmentReason["ESCALATION_ACCEPTED"] = "ESCALATION_ACCEPTED";
    LeadReassignmentReason["SURGE_LEAD_CLAIMED"] = "SURGE_LEAD_CLAIMED";
    LeadReassignmentReason["OTHER"] = "OTHER";
})(LeadReassignmentReason || (LeadReassignmentReason = {}));
var LeadSortOrder;
(function (LeadSortOrder) {
    LeadSortOrder["ACTIVITY_DATE"] = "ACTIVITY_DATE";
    LeadSortOrder["CREATION_DATE"] = "CREATION_DATE";
    LeadSortOrder["CURATION_DATE"] = "CURATION_DATE";
})(LeadSortOrder || (LeadSortOrder = {}));
var LeadSupportTaskReason;
(function (LeadSupportTaskReason) {
    LeadSupportTaskReason["NEW_UNASSIGNED_LEAD"] = "NEW_UNASSIGNED_LEAD";
    LeadSupportTaskReason["EXPERT_OUT_OF_SLA"] = "EXPERT_OUT_OF_SLA";
    LeadSupportTaskReason["ESCALATION_FAILED"] = "ESCALATION_FAILED";
    LeadSupportTaskReason["ESCALATION_FOR_DELEGATION_FAILED"] = "ESCALATION_FOR_DELEGATION_FAILED";
    LeadSupportTaskReason["ESCALATION_FOR_REASSIGNMENT_FAILED"] = "ESCALATION_FOR_REASSIGNMENT_FAILED";
    LeadSupportTaskReason["UNSNOOZED"] = "UNSNOOZED";
    LeadSupportTaskReason["RESPONDED_TO_SUPPORT"] = "RESPONDED_TO_SUPPORT";
    LeadSupportTaskReason["EVALUATE_CONVERSATION"] = "EVALUATE_CONVERSATION";
    LeadSupportTaskReason["DEFAULT"] = "DEFAULT";
})(LeadSupportTaskReason || (LeadSupportTaskReason = {}));
var ListPathFlowQuestionRenderStyle;
(function (ListPathFlowQuestionRenderStyle) {
    ListPathFlowQuestionRenderStyle["DEFAULT"] = "DEFAULT";
    ListPathFlowQuestionRenderStyle["FULL_WIDTH_IMAGES"] = "FULL_WIDTH_IMAGES";
    ListPathFlowQuestionRenderStyle["OVERLAY_IMAGE"] = "OVERLAY_IMAGE";
    ListPathFlowQuestionRenderStyle["SIMPLE_RADIO"] = "SIMPLE_RADIO";
})(ListPathFlowQuestionRenderStyle || (ListPathFlowQuestionRenderStyle = {}));
var ListPathFlowQuestionType;
(function (ListPathFlowQuestionType) {
    ListPathFlowQuestionType["SINGLE_SELECT_LIST"] = "SINGLE_SELECT_LIST";
    ListPathFlowQuestionType["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
    ListPathFlowQuestionType["DROP_DOWN"] = "DROP_DOWN";
    ListPathFlowQuestionType["MULTI_SELECT_PILLS"] = "MULTI_SELECT_PILLS";
})(ListPathFlowQuestionType || (ListPathFlowQuestionType = {}));
var LogicalConditionOperator;
(function (LogicalConditionOperator) {
    LogicalConditionOperator["AND"] = "AND";
    LogicalConditionOperator["OR"] = "OR";
})(LogicalConditionOperator || (LogicalConditionOperator = {}));
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["AND"] = "AND";
    LogicalOperator["OR"] = "OR";
})(LogicalOperator || (LogicalOperator = {}));
var LookupReferralCodeError;
(function (LookupReferralCodeError) {
    LookupReferralCodeError["INVALID_CODE"] = "INVALID_CODE";
})(LookupReferralCodeError || (LookupReferralCodeError = {}));
var LtvType;
(function (LtvType) {
    LtvType["LEAD"] = "LEAD";
    LtvType["REQUEST"] = "REQUEST";
    LtvType["RESPONSE"] = "RESPONSE";
    LtvType["VIEW_CURATIONS"] = "VIEW_CURATIONS";
})(LtvType || (LtvType = {}));
var MessageBodyType;
(function (MessageBodyType) {
    MessageBodyType["TEXT"] = "TEXT";
    MessageBodyType["FILE"] = "FILE";
    MessageBodyType["AUDIO"] = "AUDIO";
    MessageBodyType["VIDEO"] = "VIDEO";
    MessageBodyType["IMAGE"] = "IMAGE";
    MessageBodyType["MULTI_MEDIA"] = "MULTI_MEDIA";
    MessageBodyType["OFFER"] = "OFFER";
    MessageBodyType["DEAL"] = "DEAL";
    MessageBodyType["VIDEO_CHAT_REQUESTED"] = "VIDEO_CHAT_REQUESTED";
    MessageBodyType["VIDEO_CHAT_DECLINED"] = "VIDEO_CHAT_DECLINED";
    MessageBodyType["OTHER"] = "OTHER";
})(MessageBodyType || (MessageBodyType = {}));
var MessageRichCardType;
(function (MessageRichCardType) {
    MessageRichCardType["ONBOARDING_REQUEST_CONFIRMATION"] = "ONBOARDING_REQUEST_CONFIRMATION";
    MessageRichCardType["ONBOARDING_HOW_CURATED_WORKS"] = "ONBOARDING_HOW_CURATED_WORKS";
    MessageRichCardType["ONBOARDING_EXPERT_JOINED"] = "ONBOARDING_EXPERT_JOINED";
    MessageRichCardType["NEW_CUSTOM_CURATED_ORDER"] = "NEW_CUSTOM_CURATED_ORDER";
    MessageRichCardType["NEW_BOOKABLE_CURATED_ORDER"] = "NEW_BOOKABLE_CURATED_ORDER";
    MessageRichCardType["NEW_EXPERT_CURATED_ORDER_LIST"] = "NEW_EXPERT_CURATED_ORDER_LIST";
    MessageRichCardType["CONSUMER_INTERESTED_IN_CURATED_ORDER"] = "CONSUMER_INTERESTED_IN_CURATED_ORDER";
    MessageRichCardType["NEW_EXPERT_CURATED_ITEMS"] = "NEW_EXPERT_CURATED_ITEMS";
    MessageRichCardType["NEW_SYSTEM_CURATED_ITEMS"] = "NEW_SYSTEM_CURATED_ITEMS";
    MessageRichCardType["UPDATED_EXPERT_CURATED_ITEMS"] = "UPDATED_EXPERT_CURATED_ITEMS";
    MessageRichCardType["FEEDBACK_REQUEST_FROM_EXPERT"] = "FEEDBACK_REQUEST_FROM_EXPERT";
    MessageRichCardType["REFERRAL_REQUEST_FROM_EXPERT"] = "REFERRAL_REQUEST_FROM_EXPERT";
    MessageRichCardType["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
    MessageRichCardType["SIMPLE_CURATED_ORDER"] = "SIMPLE_CURATED_ORDER";
    MessageRichCardType["CONTACT_COLLECTION_REQUEST"] = "CONTACT_COLLECTION_REQUEST";
    MessageRichCardType["GUEST_CHAT_CREATE_REQUEST"] = "GUEST_CHAT_CREATE_REQUEST";
    MessageRichCardType["PAYMENT_VERIFICATION_REQUEST"] = "PAYMENT_VERIFICATION_REQUEST";
    MessageRichCardType["EXPERT_AWAY_AUTO_REPLY"] = "EXPERT_AWAY_AUTO_REPLY";
    MessageRichCardType["SELLABLE_REQUESTED"] = "SELLABLE_REQUESTED";
    MessageRichCardType["SELLABLE_PRICE_MATCH_REQUESTED"] = "SELLABLE_PRICE_MATCH_REQUESTED";
})(MessageRichCardType || (MessageRichCardType = {}));
var MessageUnsubscribeTag;
(function (MessageUnsubscribeTag) {
    MessageUnsubscribeTag["CURATION"] = "CURATION";
    MessageUnsubscribeTag["ONBOARDING"] = "ONBOARDING";
    MessageUnsubscribeTag["MESSAGE_NOTIFICATION"] = "MESSAGE_NOTIFICATION";
    MessageUnsubscribeTag["POST_PURCHASE"] = "POST_PURCHASE";
    MessageUnsubscribeTag["ABANDONED_ORDER"] = "ABANDONED_ORDER";
    MessageUnsubscribeTag["PATH_ONBOARDING"] = "PATH_ONBOARDING";
    MessageUnsubscribeTag["REFERRAL"] = "REFERRAL";
    MessageUnsubscribeTag["LEAD_CAMPAIGN"] = "LEAD_CAMPAIGN";
})(MessageUnsubscribeTag || (MessageUnsubscribeTag = {}));
var MessagingChannelType;
(function (MessagingChannelType) {
    MessagingChannelType["SMS"] = "SMS";
    MessagingChannelType["EMAIL"] = "EMAIL";
    MessagingChannelType["FACEBOOK"] = "FACEBOOK";
    MessagingChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(MessagingChannelType || (MessagingChannelType = {}));
var MessagingUserType;
(function (MessagingUserType) {
    MessagingUserType["USER"] = "USER";
    MessagingUserType["MERCHANT"] = "MERCHANT";
    MessagingUserType["BUSINESS_USER"] = "BUSINESS_USER";
    MessagingUserType["OPERATOR"] = "OPERATOR";
    MessagingUserType["DEAL_BOT"] = "DEAL_BOT";
    MessagingUserType["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
    MessagingUserType["SUPPORT"] = "SUPPORT";
})(MessagingUserType || (MessagingUserType = {}));
var MonetaryAmountDenominationType;
(function (MonetaryAmountDenominationType) {
    MonetaryAmountDenominationType["DEFAULT"] = "DEFAULT";
    MonetaryAmountDenominationType["SMALLEST"] = "SMALLEST";
})(MonetaryAmountDenominationType || (MonetaryAmountDenominationType = {}));
var NumericPathFlowQuestionDisplayType;
(function (NumericPathFlowQuestionDisplayType) {
    NumericPathFlowQuestionDisplayType["HEIGHT_IN_INCHES"] = "HEIGHT_IN_INCHES";
    NumericPathFlowQuestionDisplayType["STAR_RATING"] = "STAR_RATING";
})(NumericPathFlowQuestionDisplayType || (NumericPathFlowQuestionDisplayType = {}));
var NumericPathFlowQuestionUnitType;
(function (NumericPathFlowQuestionUnitType) {
    NumericPathFlowQuestionUnitType["INCHES"] = "INCHES";
    NumericPathFlowQuestionUnitType["FEET"] = "FEET";
    NumericPathFlowQuestionUnitType["POUNDS"] = "POUNDS";
    NumericPathFlowQuestionUnitType["CENTIMETERS"] = "CENTIMETERS";
    NumericPathFlowQuestionUnitType["KILOGRAMS"] = "KILOGRAMS";
    NumericPathFlowQuestionUnitType["DOLLARS"] = "DOLLARS";
})(NumericPathFlowQuestionUnitType || (NumericPathFlowQuestionUnitType = {}));
var NumericPathFlowQuestionValueType;
(function (NumericPathFlowQuestionValueType) {
    NumericPathFlowQuestionValueType["INTEGER"] = "INTEGER";
    NumericPathFlowQuestionValueType["DECIMAL"] = "DECIMAL";
})(NumericPathFlowQuestionValueType || (NumericPathFlowQuestionValueType = {}));
var NumericRangeDisplayFacetType;
(function (NumericRangeDisplayFacetType) {
    NumericRangeDisplayFacetType["DEFAULT"] = "DEFAULT";
    NumericRangeDisplayFacetType["USD_CURRENCY"] = "USD_CURRENCY";
})(NumericRangeDisplayFacetType || (NumericRangeDisplayFacetType = {}));
var OAuthType;
(function (OAuthType) {
    OAuthType["FACEBOOK"] = "FACEBOOK";
    OAuthType["GOOGLE"] = "GOOGLE";
    OAuthType["APPLE"] = "APPLE";
})(OAuthType || (OAuthType = {}));
var OfferState;
(function (OfferState) {
    OfferState["INITIAL"] = "INITIAL";
    OfferState["GENERATED"] = "GENERATED";
    OfferState["ACCEPTED"] = "ACCEPTED";
    OfferState["EXPIRED"] = "EXPIRED";
    OfferState["WITHDRAWN"] = "WITHDRAWN";
})(OfferState || (OfferState = {}));
var OperatorPermission;
(function (OperatorPermission) {
    OperatorPermission["UI_OPS_MANAGE_CATALOG"] = "UI_OPS_MANAGE_CATALOG";
    OperatorPermission["UI_OPS_MANAGE_LEADS"] = "UI_OPS_MANAGE_LEADS";
    OperatorPermission["UI_OPS_MANAGE_CONSUMERS"] = "UI_OPS_MANAGE_CONSUMERS";
    OperatorPermission["UI_OPS_MANAGE_MERCHANTS"] = "UI_OPS_MANAGE_MERCHANTS";
    OperatorPermission["UI_OPS_MANAGE_EXPERTS"] = "UI_OPS_MANAGE_EXPERTS";
    OperatorPermission["UI_OPS_DEVTOOLS"] = "UI_OPS_DEVTOOLS";
    OperatorPermission["UI_OPS_MANAGE_ALL_ORDERS"] = "UI_OPS_MANAGE_ALL_ORDERS";
    OperatorPermission["UI_OPS_MANAGE_PAYROLL"] = "UI_OPS_MANAGE_PAYROLL";
    OperatorPermission["UI_OPS_MANAGE_ASSIGNED_ORDERS"] = "UI_OPS_MANAGE_ASSIGNED_ORDERS";
    OperatorPermission["UI_OPS_RESEARCH_ORDER_FULFILLMENT"] = "UI_OPS_RESEARCH_ORDER_FULFILLMENT";
    OperatorPermission["UI_OPS_FULFILL_ORDERS"] = "UI_OPS_FULFILL_ORDERS";
    OperatorPermission["UI_OPS_TEST_TRIGGER"] = "UI_OPS_TEST_TRIGGER";
    OperatorPermission["UI_OPS_ASSISTANT"] = "UI_OPS_ASSISTANT";
    OperatorPermission["UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF"] = "UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF";
    OperatorPermission["UI_OPS_ORDER_SUPPORT_EXPERIMENT"] = "UI_OPS_ORDER_SUPPORT_EXPERIMENT";
})(OperatorPermission || (OperatorPermission = {}));
var OperatorRole;
(function (OperatorRole) {
    OperatorRole["CATALOG_MANAGER"] = "CATALOG_MANAGER";
    OperatorRole["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
    OperatorRole["LEAD_SUPPORT"] = "LEAD_SUPPORT";
    OperatorRole["ORDER_SUPPORT"] = "ORDER_SUPPORT";
    OperatorRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    OperatorRole["ADMIN"] = "ADMIN";
    OperatorRole["FULFILLMENT_AGENT"] = "FULFILLMENT_AGENT";
    OperatorRole["PAYROLL_MANAGER"] = "PAYROLL_MANAGER";
    OperatorRole["CONTENT_MARKETING_MANAGER"] = "CONTENT_MARKETING_MANAGER";
    OperatorRole["ORDER_SUPPORT_LEAD"] = "ORDER_SUPPORT_LEAD";
    OperatorRole["ORDER_PAYMENT_MANAGER"] = "ORDER_PAYMENT_MANAGER";
    OperatorRole["ORDER_SUPPORT_EXPERIMENT"] = "ORDER_SUPPORT_EXPERIMENT";
})(OperatorRole || (OperatorRole = {}));
var OrderActivityDetailType;
(function (OrderActivityDetailType) {
    OrderActivityDetailType["OPERATOR_ASSIGNED"] = "OPERATOR_ASSIGNED";
    OrderActivityDetailType["MERCHANT_CLAIMED"] = "MERCHANT_CLAIMED";
    OrderActivityDetailType["TRACKING_UPDATED"] = "TRACKING_UPDATED";
    OrderActivityDetailType["TRACKING_REMOVED"] = "TRACKING_REMOVED";
    OrderActivityDetailType["ORDER_ESCALATED"] = "ORDER_ESCALATED";
    OrderActivityDetailType["ITEM_SHIPPED"] = "ITEM_SHIPPED";
    OrderActivityDetailType["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
    OrderActivityDetailType["DEAL_INVENTORY_REQUESTED"] = "DEAL_INVENTORY_REQUESTED";
    OrderActivityDetailType["DEAL_INVENTORY_REQUEST_FAILED"] = "DEAL_INVENTORY_REQUEST_FAILED";
    OrderActivityDetailType["DEAL_INVENTORY_REQUEST_CANCELED"] = "DEAL_INVENTORY_REQUEST_CANCELED";
    OrderActivityDetailType["DEAL_INVENTORY_CLAIMED"] = "DEAL_INVENTORY_CLAIMED";
    OrderActivityDetailType["DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED"] = "DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED";
    OrderActivityDetailType["ITEM_RETURN_REQUESTED"] = "ITEM_RETURN_REQUESTED";
    OrderActivityDetailType["RETURN_SHIPMENT_TRACKING_UPDATED"] = "RETURN_SHIPMENT_TRACKING_UPDATED";
    OrderActivityDetailType["ITEM_RETURN_SHIPPED"] = "ITEM_RETURN_SHIPPED";
    OrderActivityDetailType["ITEM_RETURN_RECEIVED"] = "ITEM_RETURN_RECEIVED";
    OrderActivityDetailType["RETURN_SHIPMENT_TRACKING_REMOVED"] = "RETURN_SHIPMENT_TRACKING_REMOVED";
    OrderActivityDetailType["FULFILLMENT_PROCESS_UPDATED"] = "FULFILLMENT_PROCESS_UPDATED";
    OrderActivityDetailType["ITEM_RECEIVED"] = "ITEM_RECEIVED";
    OrderActivityDetailType["ITEM_ORDER_VERIFICATION"] = "ITEM_ORDER_VERIFICATION";
    OrderActivityDetailType["REFUND_REQUESTED"] = "REFUND_REQUESTED";
    OrderActivityDetailType["REFUND_STATE_UPDATED"] = "REFUND_STATE_UPDATED";
    OrderActivityDetailType["REFUND_AMOUNT_ADJUSTED"] = "REFUND_AMOUNT_ADJUSTED";
    OrderActivityDetailType["ORDER_ADDRESS_CHANGED"] = "ORDER_ADDRESS_CHANGED";
    OrderActivityDetailType["EXPERT_CONTRIBUTION_CHANGED"] = "EXPERT_CONTRIBUTION_CHANGED";
    OrderActivityDetailType["RETURN_DESTINATION_CHANGED"] = "RETURN_DESTINATION_CHANGED";
    OrderActivityDetailType["MERCHANT_REFUND_UPDATED"] = "MERCHANT_REFUND_UPDATED";
    OrderActivityDetailType["CONFIRMED_RETURN_LABEL_SENT"] = "CONFIRMED_RETURN_LABEL_SENT";
})(OrderActivityDetailType || (OrderActivityDetailType = {}));
var OrderChargeableStatusType;
(function (OrderChargeableStatusType) {
    OrderChargeableStatusType["CAN_CHARGE"] = "CAN_CHARGE";
    OrderChargeableStatusType["ALREADY_CHARGED"] = "ALREADY_CHARGED";
    OrderChargeableStatusType["EMPTY"] = "EMPTY";
    OrderChargeableStatusType["NO_SHIPPING_ADDRESS"] = "NO_SHIPPING_ADDRESS";
    OrderChargeableStatusType["NO_SERVICE_LOCATION"] = "NO_SERVICE_LOCATION";
    OrderChargeableStatusType["EXPIRED"] = "EXPIRED";
    OrderChargeableStatusType["BELOW_MINIMUM_AMOUNT"] = "BELOW_MINIMUM_AMOUNT";
    OrderChargeableStatusType["IN_PREVIEW"] = "IN_PREVIEW";
})(OrderChargeableStatusType || (OrderChargeableStatusType = {}));
var OrderChargeableUseCase;
(function (OrderChargeableUseCase) {
    OrderChargeableUseCase["CHECKOUT"] = "CHECKOUT";
    OrderChargeableUseCase["PURCHASE"] = "PURCHASE";
})(OrderChargeableUseCase || (OrderChargeableUseCase = {}));
var OrderCostComponent;
(function (OrderCostComponent) {
    OrderCostComponent["CORE"] = "CORE";
    OrderCostComponent["EXPERT_TIP"] = "EXPERT_TIP";
    OrderCostComponent["GRATUITY"] = "GRATUITY";
    OrderCostComponent["PREPAID_INCIDENTAL"] = "PREPAID_INCIDENTAL";
    OrderCostComponent["SHIPMENT"] = "SHIPMENT";
    OrderCostComponent["TAX_ADJUSTMENTS"] = "TAX_ADJUSTMENTS";
    OrderCostComponent["DISCOUNT_ADJUSTMENTS"] = "DISCOUNT_ADJUSTMENTS";
    OrderCostComponent["REFUNDS"] = "REFUNDS";
})(OrderCostComponent || (OrderCostComponent = {}));
var OrderEscalationLabel;
(function (OrderEscalationLabel) {
    OrderEscalationLabel["NEED_CONSUMER_INPUT"] = "NEED_CONSUMER_INPUT";
    OrderEscalationLabel["NEED_MERCHANT_INPUT"] = "NEED_MERCHANT_INPUT";
})(OrderEscalationLabel || (OrderEscalationLabel = {}));
var OrderEscalationPriority;
(function (OrderEscalationPriority) {
    OrderEscalationPriority["HIGH"] = "HIGH";
    OrderEscalationPriority["NORMAL"] = "NORMAL";
})(OrderEscalationPriority || (OrderEscalationPriority = {}));
var OrderEscalationSearchSort;
(function (OrderEscalationSearchSort) {
    OrderEscalationSearchSort["CREATED_AT"] = "CREATED_AT";
    OrderEscalationSearchSort["STATUS"] = "STATUS";
    OrderEscalationSearchSort["ORDER_ID"] = "ORDER_ID";
    OrderEscalationSearchSort["USER_ID"] = "USER_ID";
    OrderEscalationSearchSort["PAID_AT"] = "PAID_AT";
})(OrderEscalationSearchSort || (OrderEscalationSearchSort = {}));
var OrderEscalationSource;
(function (OrderEscalationSource) {
    OrderEscalationSource["CONSUMER"] = "CONSUMER";
    OrderEscalationSource["EXPERT"] = "EXPERT";
    OrderEscalationSource["OPERATIONS"] = "OPERATIONS";
})(OrderEscalationSource || (OrderEscalationSource = {}));
var OrderEscalationStatus;
(function (OrderEscalationStatus) {
    OrderEscalationStatus["NEW"] = "NEW";
    OrderEscalationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OrderEscalationStatus["COMPLETED"] = "COMPLETED";
})(OrderEscalationStatus || (OrderEscalationStatus = {}));
var OrderEscalationType;
(function (OrderEscalationType) {
    OrderEscalationType["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
    OrderEscalationType["MISSING_SPECS"] = "MISSING_SPECS";
    OrderEscalationType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
    OrderEscalationType["CANCELLATION"] = "CANCELLATION";
    OrderEscalationType["RETURN"] = "RETURN";
    OrderEscalationType["EXCHANGE"] = "EXCHANGE";
    OrderEscalationType["MISSING_ITEM"] = "MISSING_ITEM";
    OrderEscalationType["TRACKING_INQUIRY"] = "TRACKING_INQUIRY";
    OrderEscalationType["ORDER_INFORMATION"] = "ORDER_INFORMATION";
    OrderEscalationType["OTHER"] = "OTHER";
})(OrderEscalationType || (OrderEscalationType = {}));
var OrderFulfillmentState;
(function (OrderFulfillmentState) {
    OrderFulfillmentState["NEW"] = "NEW";
    OrderFulfillmentState["CLAIMED"] = "CLAIMED";
    OrderFulfillmentState["READY"] = "READY";
    OrderFulfillmentState["FULFILLED"] = "FULFILLED";
})(OrderFulfillmentState || (OrderFulfillmentState = {}));
var OrderLabel;
(function (OrderLabel) {
    OrderLabel["UNCLAIMED"] = "UNCLAIMED";
    OrderLabel["TRACKING_NEEDED"] = "TRACKING_NEEDED";
    OrderLabel["TRACKING_OVERDUE"] = "TRACKING_OVERDUE";
})(OrderLabel || (OrderLabel = {}));
var OrderLineItemGroupPriceStrategy;
(function (OrderLineItemGroupPriceStrategy) {
    OrderLineItemGroupPriceStrategy["IGNORE_SELF_DEFAULT_CHILDREN"] = "IGNORE_SELF_DEFAULT_CHILDREN";
    OrderLineItemGroupPriceStrategy["ONLY_SELF_IGNORE_CHILDREN"] = "ONLY_SELF_IGNORE_CHILDREN";
})(OrderLineItemGroupPriceStrategy || (OrderLineItemGroupPriceStrategy = {}));
var OrderLineItemGroupTaxStrategy;
(function (OrderLineItemGroupTaxStrategy) {
    OrderLineItemGroupTaxStrategy["DEFAULT"] = "DEFAULT";
    OrderLineItemGroupTaxStrategy["PROPAGATE_SELF_TO_CHILDREN"] = "PROPAGATE_SELF_TO_CHILDREN";
})(OrderLineItemGroupTaxStrategy || (OrderLineItemGroupTaxStrategy = {}));
var OrderLineItemsGroupingType;
(function (OrderLineItemsGroupingType) {
    OrderLineItemsGroupingType["TRACKING"] = "TRACKING";
})(OrderLineItemsGroupingType || (OrderLineItemsGroupingType = {}));
var OrderLineItemSourceType;
(function (OrderLineItemSourceType) {
    OrderLineItemSourceType["AD_HOC"] = "AD_HOC";
    OrderLineItemSourceType["SELLABLE"] = "SELLABLE";
    OrderLineItemSourceType["BASE_PRICE"] = "BASE_PRICE";
    OrderLineItemSourceType["EXPERT_TIP"] = "EXPERT_TIP";
    OrderLineItemSourceType["GRATUITY"] = "GRATUITY";
    OrderLineItemSourceType["PREPAID_INCIDENTAL"] = "PREPAID_INCIDENTAL";
    OrderLineItemSourceType["SHIPMENT"] = "SHIPMENT";
    OrderLineItemSourceType["REFUND"] = "REFUND";
})(OrderLineItemSourceType || (OrderLineItemSourceType = {}));
var OrderLineItemState;
(function (OrderLineItemState) {
    OrderLineItemState["PENDING_CLAIM"] = "PENDING_CLAIM";
    OrderLineItemState["CLAIMED"] = "CLAIMED";
    OrderLineItemState["NEW"] = "NEW";
    OrderLineItemState["PAID"] = "PAID";
    OrderLineItemState["READY_TO_CLAIM"] = "READY_TO_CLAIM";
    OrderLineItemState["PENDING_SHIPPING"] = "PENDING_SHIPPING";
    OrderLineItemState["READY"] = "READY";
    OrderLineItemState["RECEIVED"] = "RECEIVED";
    OrderLineItemState["RETURN_PENDING_SHIPPING"] = "RETURN_PENDING_SHIPPING";
    OrderLineItemState["RETURN_REQUESTED"] = "RETURN_REQUESTED";
    OrderLineItemState["RETURN_RECEIVED"] = "RETURN_RECEIVED";
    OrderLineItemState["RETURN_SHIPPED"] = "RETURN_SHIPPED";
    OrderLineItemState["SHIPPED"] = "SHIPPED";
    OrderLineItemState["UNAVAILABLE"] = "UNAVAILABLE";
    OrderLineItemState["CUSTOMIZING"] = "CUSTOMIZING";
})(OrderLineItemState || (OrderLineItemState = {}));
var OrderPreSubmitAction;
(function (OrderPreSubmitAction) {
    OrderPreSubmitAction["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
    OrderPreSubmitAction["ADD_TO_CART"] = "ADD_TO_CART";
    OrderPreSubmitAction["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
})(OrderPreSubmitAction || (OrderPreSubmitAction = {}));
var OrderRefundReason;
(function (OrderRefundReason) {
    OrderRefundReason["DIDNT_LIKE"] = "DIDNT_LIKE";
    OrderRefundReason["NOT_EXPECTED"] = "NOT_EXPECTED";
    OrderRefundReason["WRONG_ITEM"] = "WRONG_ITEM";
    OrderRefundReason["BAD_DESCRIPTION"] = "BAD_DESCRIPTION";
    OrderRefundReason["DEFECTIVE"] = "DEFECTIVE";
    OrderRefundReason["DAMAGED_IN_SHIPPING"] = "DAMAGED_IN_SHIPPING";
    OrderRefundReason["NEVER_ARRIVED"] = "NEVER_ARRIVED";
    OrderRefundReason["ARRIVED_LATE"] = "ARRIVED_LATE";
    OrderRefundReason["UNAPPROVED"] = "UNAPPROVED";
    OrderRefundReason["BAD_WEATHER"] = "BAD_WEATHER";
    OrderRefundReason["EQUIPMENT_MALFUNCTION"] = "EQUIPMENT_MALFUNCTION";
    OrderRefundReason["WRONG_AMOUNT"] = "WRONG_AMOUNT";
    OrderRefundReason["WRONG_SIZE"] = "WRONG_SIZE";
    OrderRefundReason["WRONG_COLOR"] = "WRONG_COLOR";
    OrderRefundReason["DAMAGED_SHIPPING_BOX_OK"] = "DAMAGED_SHIPPING_BOX_OK";
    OrderRefundReason["DAMAGED_SHIPPING_BOX_DAMAGED"] = "DAMAGED_SHIPPING_BOX_DAMAGED";
    OrderRefundReason["UNAVAILABLE_INVENTORY"] = "UNAVAILABLE_INVENTORY";
    OrderRefundReason["REPLACED_INVENTORY"] = "REPLACED_INVENTORY";
    OrderRefundReason["LOST_DURING_SHIPPING"] = "LOST_DURING_SHIPPING";
    OrderRefundReason["UNABLE_TO_EXPEDITE_SHIPPING"] = "UNABLE_TO_EXPEDITE_SHIPPING";
    OrderRefundReason["PRICE_MATCH"] = "PRICE_MATCH";
    OrderRefundReason["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
})(OrderRefundReason || (OrderRefundReason = {}));
var OrderRefundStatus;
(function (OrderRefundStatus) {
    OrderRefundStatus["SUCCESS"] = "SUCCESS";
    OrderRefundStatus["PENDING"] = "PENDING";
    OrderRefundStatus["FAILED"] = "FAILED";
    OrderRefundStatus["REJECTED"] = "REJECTED";
    OrderRefundStatus["CANCELLED"] = "CANCELLED";
})(OrderRefundStatus || (OrderRefundStatus = {}));
var OrderRefundType;
(function (OrderRefundType) {
    OrderRefundType["REFUND"] = "REFUND";
    OrderRefundType["RETURN"] = "RETURN";
    OrderRefundType["CANCELLATION"] = "CANCELLATION";
})(OrderRefundType || (OrderRefundType = {}));
var OrderSearchSort;
(function (OrderSearchSort) {
    OrderSearchSort["PAID_AT"] = "PAID_AT";
    OrderSearchSort["CREATED_AT"] = "CREATED_AT";
    OrderSearchSort["EFFECTIVE_ORDER_DATE"] = "EFFECTIVE_ORDER_DATE";
    OrderSearchSort["EFFECTIVE_ORDER_DATE_ASC"] = "EFFECTIVE_ORDER_DATE_ASC";
})(OrderSearchSort || (OrderSearchSort = {}));
var OrderState;
(function (OrderState) {
    OrderState["CART"] = "CART";
    OrderState["CREATED"] = "CREATED";
    OrderState["SUBMITTED"] = "SUBMITTED";
    OrderState["CONSUMER_PAYMENT_PENDING"] = "CONSUMER_PAYMENT_PENDING";
    OrderState["CONSUMER_PAYMENT_IN_REVIEW"] = "CONSUMER_PAYMENT_IN_REVIEW";
    OrderState["CONSUMER_PAYMENT_COMPLETED"] = "CONSUMER_PAYMENT_COMPLETED";
    OrderState["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
    OrderState["CONSUMER_PAYMENT_PARTIAL"] = "CONSUMER_PAYMENT_PARTIAL";
    OrderState["CONSUMER_OVERPAID"] = "CONSUMER_OVERPAID";
    OrderState["CONSUMER_PAYMENT_REFUNDED"] = "CONSUMER_PAYMENT_REFUNDED";
    OrderState["CONSUMER_PAYMENT_CANCELED"] = "CONSUMER_PAYMENT_CANCELED";
})(OrderState || (OrderState = {}));
var PathFlowOnCompleteRedirectLocation;
(function (PathFlowOnCompleteRedirectLocation) {
    PathFlowOnCompleteRedirectLocation["RELOAD_CURRENT_PAGE"] = "RELOAD_CURRENT_PAGE";
    PathFlowOnCompleteRedirectLocation["EXPERT_PROFILE"] = "EXPERT_PROFILE";
    PathFlowOnCompleteRedirectLocation["INBOX"] = "INBOX";
    PathFlowOnCompleteRedirectLocation["LOGIN"] = "LOGIN";
    PathFlowOnCompleteRedirectLocation["APPLY_FINISH"] = "APPLY_FINISH";
    PathFlowOnCompleteRedirectLocation["DEPARTMENT_PAGE"] = "DEPARTMENT_PAGE";
    PathFlowOnCompleteRedirectLocation["CATEGORY"] = "CATEGORY";
    PathFlowOnCompleteRedirectLocation["PHONE_COLLECTION_PATH"] = "PHONE_COLLECTION_PATH";
})(PathFlowOnCompleteRedirectLocation || (PathFlowOnCompleteRedirectLocation = {}));
var PathFlowPageMetadataType;
(function (PathFlowPageMetadataType) {
    PathFlowPageMetadataType["INTERSTITIAL"] = "INTERSTITIAL";
    PathFlowPageMetadataType["CUSTOM"] = "CUSTOM";
    PathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
    PathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
    PathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
    PathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
    PathFlowPageMetadataType["WELCOME"] = "WELCOME";
})(PathFlowPageMetadataType || (PathFlowPageMetadataType = {}));
var PathFlowThemeType;
(function (PathFlowThemeType) {
    PathFlowThemeType["DEFAULT"] = "DEFAULT";
    PathFlowThemeType["SNOWBOARD"] = "SNOWBOARD";
    PathFlowThemeType["CHAT_LIKE"] = "CHAT_LIKE";
})(PathFlowThemeType || (PathFlowThemeType = {}));
var PathValidationErrorTag;
(function (PathValidationErrorTag) {
    PathValidationErrorTag["REQUIRES_LOGIN_TO_PROCEED"] = "REQUIRES_LOGIN_TO_PROCEED";
    PathValidationErrorTag["INTERNAL"] = "INTERNAL";
})(PathValidationErrorTag || (PathValidationErrorTag = {}));
var PayComponentType;
(function (PayComponentType) {
    PayComponentType["COMMISSION"] = "COMMISSION";
    PayComponentType["QUALITY_CONVERSATION"] = "QUALITY_CONVERSATION";
    PayComponentType["TIP"] = "TIP";
    PayComponentType["FIRST_SHIFTS_GUARANTEED_PAY"] = "FIRST_SHIFTS_GUARANTEED_PAY";
    PayComponentType["HOURLY_ON_CALL"] = "HOURLY_ON_CALL";
    PayComponentType["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
    PayComponentType["REFERRAL_FIRST_ORDER"] = "REFERRAL_FIRST_ORDER";
})(PayComponentType || (PayComponentType = {}));
var PayLineItemSortField;
(function (PayLineItemSortField) {
    PayLineItemSortField["PAY_COMPONENT_TYPE"] = "PAY_COMPONENT_TYPE";
    PayLineItemSortField["POSTED_AT"] = "POSTED_AT";
    PayLineItemSortField["AMOUNT"] = "AMOUNT";
})(PayLineItemSortField || (PayLineItemSortField = {}));
var PaymentActivityType;
(function (PaymentActivityType) {
    PaymentActivityType["FULL_PAYMENT"] = "FULL_PAYMENT";
    PaymentActivityType["DEPOSIT"] = "DEPOSIT";
    PaymentActivityType["REMAINING_BALANCE"] = "REMAINING_BALANCE";
})(PaymentActivityType || (PaymentActivityType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CARD"] = "CARD";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["THREE_D_SECURE"] = "THREE_D_SECURE";
    PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    PaymentMethod["ANDROID_PAY"] = "ANDROID_PAY";
    PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    PaymentMethod["PAY_BY_INSTALLMENT"] = "PAY_BY_INSTALLMENT";
    PaymentMethod["WIRE_TRANSFER"] = "WIRE_TRANSFER";
    PaymentMethod["BANK_CHECK"] = "BANK_CHECK";
})(PaymentMethod || (PaymentMethod = {}));
var PaymentProcessorType;
(function (PaymentProcessorType) {
    PaymentProcessorType["STRIPE"] = "STRIPE";
    PaymentProcessorType["PAYPAL"] = "PAYPAL";
    PaymentProcessorType["AFTERPAY"] = "AFTERPAY";
    PaymentProcessorType["AFFIRM"] = "AFFIRM";
    PaymentProcessorType["DEAL"] = "DEAL";
})(PaymentProcessorType || (PaymentProcessorType = {}));
var PaymentSourceStatus;
(function (PaymentSourceStatus) {
    PaymentSourceStatus["ARCHIVED"] = "ARCHIVED";
    PaymentSourceStatus["CANCELED"] = "CANCELED";
    PaymentSourceStatus["CHARGEABLE"] = "CHARGEABLE";
    PaymentSourceStatus["CONSUMED"] = "CONSUMED";
    PaymentSourceStatus["FAILED"] = "FAILED";
    PaymentSourceStatus["PENDING"] = "PENDING";
})(PaymentSourceStatus || (PaymentSourceStatus = {}));
var PaymentSourceUsage;
(function (PaymentSourceUsage) {
    PaymentSourceUsage["REUSABLE"] = "REUSABLE";
    PaymentSourceUsage["SINGLE_USE"] = "SINGLE_USE";
})(PaymentSourceUsage || (PaymentSourceUsage = {}));
var PaymentVerificationMethod;
(function (PaymentVerificationMethod) {
    PaymentVerificationMethod["CODE"] = "CODE";
    PaymentVerificationMethod["AMOUNT"] = "AMOUNT";
})(PaymentVerificationMethod || (PaymentVerificationMethod = {}));
var PayoutSortField;
(function (PayoutSortField) {
    PayoutSortField["POSTED_AT"] = "POSTED_AT";
    PayoutSortField["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
    PayoutSortField["COMMISSION_AMOUNT"] = "COMMISSION_AMOUNT";
    PayoutSortField["QUALITY_CONVERSATION_AMOUNT"] = "QUALITY_CONVERSATION_AMOUNT";
    PayoutSortField["TIP_AMOUNT"] = "TIP_AMOUNT";
    PayoutSortField["FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT"] = "FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT";
    PayoutSortField["HOURLY_ON_CALL_AMOUNT"] = "HOURLY_ON_CALL_AMOUNT";
    PayoutSortField["MANUAL_ADJUSTMENT_AMOUNT"] = "MANUAL_ADJUSTMENT_AMOUNT";
})(PayoutSortField || (PayoutSortField = {}));
var PayoutState;
(function (PayoutState) {
    PayoutState["CREATED"] = "CREATED";
    PayoutState["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    PayoutState["APPROVED"] = "APPROVED";
    PayoutState["ERROR"] = "ERROR";
    PayoutState["PAID"] = "PAID";
    PayoutState["ARCHIVED"] = "ARCHIVED";
})(PayoutState || (PayoutState = {}));
var PayStructureRevisionState;
(function (PayStructureRevisionState) {
    PayStructureRevisionState["DRAFT"] = "DRAFT";
    PayStructureRevisionState["ACTIVE"] = "ACTIVE";
    PayStructureRevisionState["PENDING"] = "PENDING";
    PayStructureRevisionState["DEACTIVATED"] = "DEACTIVATED";
})(PayStructureRevisionState || (PayStructureRevisionState = {}));
var Permission;
(function (Permission) {
    Permission["UI_OVERWRITE_SELLABLE_PRICE"] = "UI_OVERWRITE_SELLABLE_PRICE";
    Permission["UI_ON_CALL_EXPERT"] = "UI_ON_CALL_EXPERT";
    Permission["UI_ACCEPT_NEW_LEAD"] = "UI_ACCEPT_NEW_LEAD";
})(Permission || (Permission = {}));
var PostalAddressLocationDisplayType;
(function (PostalAddressLocationDisplayType) {
    PostalAddressLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(PostalAddressLocationDisplayType || (PostalAddressLocationDisplayType = {}));
var PresenceStatus;
(function (PresenceStatus) {
    PresenceStatus["ONLINE"] = "ONLINE";
    PresenceStatus["OFFLINE"] = "OFFLINE";
    PresenceStatus["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
    PresenceStatus["SMS"] = "SMS";
})(PresenceStatus || (PresenceStatus = {}));
var ProductCondition;
(function (ProductCondition) {
    ProductCondition["NEW"] = "NEW";
    ProductCondition["EXCELLENT"] = "EXCELLENT";
    ProductCondition["GOOD"] = "GOOD";
    ProductCondition["FAIR"] = "FAIR";
})(ProductCondition || (ProductCondition = {}));
var ProductReturnDestination;
(function (ProductReturnDestination) {
    ProductReturnDestination["WAREHOUSE"] = "WAREHOUSE";
    ProductReturnDestination["MERCHANT"] = "MERCHANT";
    ProductReturnDestination["OFFICE"] = "OFFICE";
})(ProductReturnDestination || (ProductReturnDestination = {}));
var ProfileHighlightIconType;
(function (ProfileHighlightIconType) {
    ProfileHighlightIconType["BEER"] = "BEER";
    ProfileHighlightIconType["CAKE"] = "CAKE";
    ProfileHighlightIconType["CALENDAR"] = "CALENDAR";
    ProfileHighlightIconType["CHAT"] = "CHAT";
    ProfileHighlightIconType["CHECK"] = "CHECK";
    ProfileHighlightIconType["COCKTAIL"] = "COCKTAIL";
    ProfileHighlightIconType["DRINK"] = "DRINK";
    ProfileHighlightIconType["GOLF_CLUB"] = "GOLF_CLUB";
    ProfileHighlightIconType["GOLF_CLUB_SET"] = "GOLF_CLUB_SET";
    ProfileHighlightIconType["GOLF_COURSE"] = "GOLF_COURSE";
    ProfileHighlightIconType["HEART"] = "HEART";
    ProfileHighlightIconType["LOCATION"] = "LOCATION";
    ProfileHighlightIconType["DIPLOMA"] = "DIPLOMA";
    ProfileHighlightIconType["SKIER"] = "SKIER";
    ProfileHighlightIconType["SNOWBOARDER"] = "SNOWBOARDER";
    ProfileHighlightIconType["MOUNTAIN"] = "MOUNTAIN";
    ProfileHighlightIconType["SNOWFLAKE"] = "SNOWFLAKE";
    ProfileHighlightIconType["SMILE"] = "SMILE";
    ProfileHighlightIconType["STAR"] = "STAR";
})(ProfileHighlightIconType || (ProfileHighlightIconType = {}));
var ProfileHighlightSource;
(function (ProfileHighlightSource) {
    ProfileHighlightSource["SYSTEM"] = "SYSTEM";
    ProfileHighlightSource["USER"] = "USER";
})(ProfileHighlightSource || (ProfileHighlightSource = {}));
var ProfileHighlightValueType;
(function (ProfileHighlightValueType) {
    ProfileHighlightValueType["TEXT"] = "TEXT";
    ProfileHighlightValueType["ENUMERATION"] = "ENUMERATION";
    ProfileHighlightValueType["DATE"] = "DATE";
})(ProfileHighlightValueType || (ProfileHighlightValueType = {}));
var PromotionActionType;
(function (PromotionActionType) {
    PromotionActionType["PERCENT_OFF_LINE_ITEMS"] = "PERCENT_OFF_LINE_ITEMS";
    PromotionActionType["AMOUNT_OFF_ORDER"] = "AMOUNT_OFF_ORDER";
})(PromotionActionType || (PromotionActionType = {}));
var PromotionDisabledReason;
(function (PromotionDisabledReason) {
    PromotionDisabledReason["MANUAL"] = "MANUAL";
    PromotionDisabledReason["REPLACED"] = "REPLACED";
    PromotionDisabledReason["EXPIRED"] = "EXPIRED";
    PromotionDisabledReason["REACHED_USAGE_LIMIT"] = "REACHED_USAGE_LIMIT";
})(PromotionDisabledReason || (PromotionDisabledReason = {}));
var PromotionQueryFlagType;
(function (PromotionQueryFlagType) {
    PromotionQueryFlagType["INCLUDE"] = "INCLUDE";
    PromotionQueryFlagType["ONLY"] = "ONLY";
    PromotionQueryFlagType["NONE"] = "NONE";
})(PromotionQueryFlagType || (PromotionQueryFlagType = {}));
var PromotionRuleComparisonOperator;
(function (PromotionRuleComparisonOperator) {
    PromotionRuleComparisonOperator["GREATER_THAN"] = "GREATER_THAN";
    PromotionRuleComparisonOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    PromotionRuleComparisonOperator["EQUAL"] = "EQUAL";
    PromotionRuleComparisonOperator["LESS_THAN"] = "LESS_THAN";
    PromotionRuleComparisonOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
})(PromotionRuleComparisonOperator || (PromotionRuleComparisonOperator = {}));
var PromotionRuleFilterStrategy;
(function (PromotionRuleFilterStrategy) {
    PromotionRuleFilterStrategy["FILTER"] = "FILTER";
    PromotionRuleFilterStrategy["EXCLUDE"] = "EXCLUDE";
})(PromotionRuleFilterStrategy || (PromotionRuleFilterStrategy = {}));
var PromotionRuleType;
(function (PromotionRuleType) {
    PromotionRuleType["ORDER_AMOUNT"] = "ORDER_AMOUNT";
    PromotionRuleType["SELLABLE_FILTER"] = "SELLABLE_FILTER";
    PromotionRuleType["SELLABLE_CATEGORY_FILTER"] = "SELLABLE_CATEGORY_FILTER";
    PromotionRuleType["SELLABLE_BRAND_FILTER"] = "SELLABLE_BRAND_FILTER";
    PromotionRuleType["SELLABLE_ATTRIBUTE_FILTER"] = "SELLABLE_ATTRIBUTE_FILTER";
    PromotionRuleType["PURCHASED_ORDER_COUNT"] = "PURCHASED_ORDER_COUNT";
    PromotionRuleType["USER_USAGE_LIMIT"] = "USER_USAGE_LIMIT";
})(PromotionRuleType || (PromotionRuleType = {}));
var PromotionSourceType;
(function (PromotionSourceType) {
    PromotionSourceType["REFERRER"] = "REFERRER";
    PromotionSourceType["REFEREE"] = "REFEREE";
    PromotionSourceType["REGISTRATION"] = "REGISTRATION";
    PromotionSourceType["SOCIAL_SHARING"] = "SOCIAL_SHARING";
})(PromotionSourceType || (PromotionSourceType = {}));
var PromotionState;
(function (PromotionState) {
    PromotionState["DRAFT"] = "DRAFT";
    PromotionState["ACTIVE"] = "ACTIVE";
    PromotionState["DISABLED"] = "DISABLED";
})(PromotionState || (PromotionState = {}));
var RawSellableAttributeValuePatternFlag;
(function (RawSellableAttributeValuePatternFlag) {
    RawSellableAttributeValuePatternFlag["UNIX_LINES"] = "UNIX_LINES";
    RawSellableAttributeValuePatternFlag["CASE_INSENSITIVE"] = "CASE_INSENSITIVE";
    RawSellableAttributeValuePatternFlag["COMMENTS"] = "COMMENTS";
    RawSellableAttributeValuePatternFlag["MULTILINE"] = "MULTILINE";
    RawSellableAttributeValuePatternFlag["LITERAL"] = "LITERAL";
    RawSellableAttributeValuePatternFlag["DOTALL"] = "DOTALL";
    RawSellableAttributeValuePatternFlag["UNICODE_CASE"] = "UNICODE_CASE";
    RawSellableAttributeValuePatternFlag["CANON_EQ"] = "CANON_EQ";
    RawSellableAttributeValuePatternFlag["UNICODE_CHARACTER_CLASS"] = "UNICODE_CHARACTER_CLASS";
})(RawSellableAttributeValuePatternFlag || (RawSellableAttributeValuePatternFlag = {}));
var RawSellableSourceState;
(function (RawSellableSourceState) {
    RawSellableSourceState["ACTIVE"] = "ACTIVE";
    RawSellableSourceState["INACTIVE"] = "INACTIVE";
})(RawSellableSourceState || (RawSellableSourceState = {}));
var RawSellableSourceType;
(function (RawSellableSourceType) {
    RawSellableSourceType["SCRAPER"] = "SCRAPER";
    RawSellableSourceType["DEAL_INVENTORY"] = "DEAL_INVENTORY";
    RawSellableSourceType["GOOGLE_SHOPPING_FEED"] = "GOOGLE_SHOPPING_FEED";
    RawSellableSourceType["GOOGLE_SHOPPING_SEARCH"] = "GOOGLE_SHOPPING_SEARCH";
    RawSellableSourceType["LEVEL9_FEED"] = "LEVEL9_FEED";
    RawSellableSourceType["SHOPIFY"] = "SHOPIFY";
})(RawSellableSourceType || (RawSellableSourceType = {}));
var RawSellableStandardizationActionType;
(function (RawSellableStandardizationActionType) {
    RawSellableStandardizationActionType["SET_CATEGORY"] = "SET_CATEGORY";
    RawSellableStandardizationActionType["SET_ATTRIBUTE_VALUE"] = "SET_ATTRIBUTE_VALUE";
    RawSellableStandardizationActionType["COPY_ATTRIBUTE_VALUE"] = "COPY_ATTRIBUTE_VALUE";
    RawSellableStandardizationActionType["REMOVE_ATTRIBUTE"] = "REMOVE_ATTRIBUTE";
    RawSellableStandardizationActionType["REPLACE_ATTRIBUTE_VALUE"] = "REPLACE_ATTRIBUTE_VALUE";
    RawSellableStandardizationActionType["MARK_OUT_OF_STOCK"] = "MARK_OUT_OF_STOCK";
    RawSellableStandardizationActionType["DEACTIVATE"] = "DEACTIVATE";
    RawSellableStandardizationActionType["HIDE_FROM_CONSUMER_SEARCH"] = "HIDE_FROM_CONSUMER_SEARCH";
    RawSellableStandardizationActionType["SET_TITLE"] = "SET_TITLE";
    RawSellableStandardizationActionType["SET_VARIATION_GROUP_TITLE"] = "SET_VARIATION_GROUP_TITLE";
    RawSellableStandardizationActionType["SET_VARIATION_GROUP_REFERENCE"] = "SET_VARIATION_GROUP_REFERENCE";
    RawSellableStandardizationActionType["SET_BRAND"] = "SET_BRAND";
    RawSellableStandardizationActionType["SET_MPN"] = "SET_MPN";
    RawSellableStandardizationActionType["SET_ATTRIBUTE_VARIATION_DIMENSION"] = "SET_ATTRIBUTE_VARIATION_DIMENSION";
    RawSellableStandardizationActionType["SET_DESCRIPTION"] = "SET_DESCRIPTION";
    RawSellableStandardizationActionType["RENAME_ATTRIBUTE"] = "RENAME_ATTRIBUTE";
    RawSellableStandardizationActionType["MARK_NONE_VARIANT"] = "MARK_NONE_VARIANT";
})(RawSellableStandardizationActionType || (RawSellableStandardizationActionType = {}));
var RawSellableStandardizationRuleConditionType;
(function (RawSellableStandardizationRuleConditionType) {
    RawSellableStandardizationRuleConditionType["LOGICAL"] = "LOGICAL";
    RawSellableStandardizationRuleConditionType["BINARY"] = "BINARY";
    RawSellableStandardizationRuleConditionType["CONSTANT"] = "CONSTANT";
})(RawSellableStandardizationRuleConditionType || (RawSellableStandardizationRuleConditionType = {}));
var RawSellableStandardizationRuleFieldType;
(function (RawSellableStandardizationRuleFieldType) {
    RawSellableStandardizationRuleFieldType["BOOLEAN"] = "BOOLEAN";
    RawSellableStandardizationRuleFieldType["STRING"] = "STRING";
    RawSellableStandardizationRuleFieldType["STRING_LIST"] = "STRING_LIST";
    RawSellableStandardizationRuleFieldType["ID"] = "ID";
    RawSellableStandardizationRuleFieldType["ID_LIST"] = "ID_LIST";
})(RawSellableStandardizationRuleFieldType || (RawSellableStandardizationRuleFieldType = {}));
var RawSellableStandardizationRuleParameterType;
(function (RawSellableStandardizationRuleParameterType) {
    RawSellableStandardizationRuleParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
    RawSellableStandardizationRuleParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
})(RawSellableStandardizationRuleParameterType || (RawSellableStandardizationRuleParameterType = {}));
var RawSellableStandardizationRuleState;
(function (RawSellableStandardizationRuleState) {
    RawSellableStandardizationRuleState["ACTIVE"] = "ACTIVE";
    RawSellableStandardizationRuleState["INACTIVE"] = "INACTIVE";
})(RawSellableStandardizationRuleState || (RawSellableStandardizationRuleState = {}));
var RawSellableState;
(function (RawSellableState) {
    RawSellableState["ACTIVE"] = "ACTIVE";
    RawSellableState["INACTIVE"] = "INACTIVE";
})(RawSellableState || (RawSellableState = {}));
var RecommendedListType;
(function (RecommendedListType) {
    RecommendedListType["MY_TOP_LIST"] = "MY_TOP_LIST";
    RecommendedListType["STRICT_MY_TOP_LIST"] = "STRICT_MY_TOP_LIST";
    RecommendedListType["PRICE_AND_PRIMARY_ATTRIBUTES"] = "PRICE_AND_PRIMARY_ATTRIBUTES";
    RecommendedListType["BRAND_AND_PRIMARY_ATTRIBUTES"] = "BRAND_AND_PRIMARY_ATTRIBUTES";
    RecommendedListType["ACCESSORIES"] = "ACCESSORIES";
    RecommendedListType["CURATED_LIST_TO_SIMILAR_USERS"] = "CURATED_LIST_TO_SIMILAR_USERS";
    RecommendedListType["PRICE_SENSITIVE_INTENT_BASED_DIGEST"] = "PRICE_SENSITIVE_INTENT_BASED_DIGEST";
    RecommendedListType["CUSTOM"] = "CUSTOM";
})(RecommendedListType || (RecommendedListType = {}));
var ReferralMedium;
(function (ReferralMedium) {
    ReferralMedium["EMAIL"] = "EMAIL";
    ReferralMedium["FACEBOOK"] = "FACEBOOK";
    ReferralMedium["LINK"] = "LINK";
})(ReferralMedium || (ReferralMedium = {}));
var ReferralType;
(function (ReferralType) {
    ReferralType["CONSUMER_GENERIC"] = "CONSUMER_GENERIC";
    ReferralType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
    ReferralType["EXPERT_DIRECT"] = "EXPERT_DIRECT";
})(ReferralType || (ReferralType = {}));
var ReferrerIncentiveType;
(function (ReferrerIncentiveType) {
    ReferrerIncentiveType["CREDIT_FOR_SOCIAL_SHARE"] = "CREDIT_FOR_SOCIAL_SHARE";
    ReferrerIncentiveType["PERCENT_OFF_ON_FIRST_REFEREE_ORDER"] = "PERCENT_OFF_ON_FIRST_REFEREE_ORDER";
})(ReferrerIncentiveType || (ReferrerIncentiveType = {}));
var RegisterCustomerErrorCode;
(function (RegisterCustomerErrorCode) {
    RegisterCustomerErrorCode["ALREADY_REGISTERED"] = "ALREADY_REGISTERED";
    RegisterCustomerErrorCode["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    RegisterCustomerErrorCode["INVALID_EMAIL_ADDRESS"] = "INVALID_EMAIL_ADDRESS";
})(RegisterCustomerErrorCode || (RegisterCustomerErrorCode = {}));
var ReopenTicketReason;
(function (ReopenTicketReason) {
    ReopenTicketReason["NOT_RESOLVED"] = "NOT_RESOLVED";
})(ReopenTicketReason || (ReopenTicketReason = {}));
var ReportAccessScope;
(function (ReportAccessScope) {
    ReportAccessScope["BUSINESS_USER"] = "BUSINESS_USER";
    ReportAccessScope["TEAM"] = "TEAM";
    ReportAccessScope["DEPARTMENT"] = "DEPARTMENT";
    ReportAccessScope["GLOBAL"] = "GLOBAL";
})(ReportAccessScope || (ReportAccessScope = {}));
var ReportColumnFormat;
(function (ReportColumnFormat) {
    ReportColumnFormat["NONE"] = "NONE";
    ReportColumnFormat["PERCENTAGE"] = "PERCENTAGE";
    ReportColumnFormat["CURRENCY"] = "CURRENCY";
})(ReportColumnFormat || (ReportColumnFormat = {}));
var ReportColumnValueType;
(function (ReportColumnValueType) {
    ReportColumnValueType["STRING"] = "STRING";
    ReportColumnValueType["INTEGER"] = "INTEGER";
    ReportColumnValueType["DOUBLE"] = "DOUBLE";
})(ReportColumnValueType || (ReportColumnValueType = {}));
var ReportSchemaType;
(function (ReportSchemaType) {
    ReportSchemaType["CONVERSATIONS_COUNT"] = "CONVERSATIONS_COUNT";
    ReportSchemaType["EXPERT_RATING_STATS"] = "EXPERT_RATING_STATS";
    ReportSchemaType["CURATIONS_COUNT"] = "CURATIONS_COUNT";
    ReportSchemaType["RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS";
    ReportSchemaType["RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS";
})(ReportSchemaType || (ReportSchemaType = {}));
var ReturnPolicyType;
(function (ReturnPolicyType) {
    ReturnPolicyType["NO_RETURNS_ACCEPTED"] = "NO_RETURNS_ACCEPTED";
    ReturnPolicyType["STANDARD"] = "STANDARD";
})(ReturnPolicyType || (ReturnPolicyType = {}));
var ReturnRefundMethod;
(function (ReturnRefundMethod) {
    ReturnRefundMethod["ORIGINAL_PAYMENT"] = "ORIGINAL_PAYMENT";
    ReturnRefundMethod["STORE_CREDIT"] = "STORE_CREDIT";
})(ReturnRefundMethod || (ReturnRefundMethod = {}));
var ReturnShippingPaidBy;
(function (ReturnShippingPaidBy) {
    ReturnShippingPaidBy["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ReturnShippingPaidBy["MERCHANT"] = "MERCHANT";
    ReturnShippingPaidBy["CUSTOMER"] = "CUSTOMER";
})(ReturnShippingPaidBy || (ReturnShippingPaidBy = {}));
var RevisionChangeType;
(function (RevisionChangeType) {
    RevisionChangeType["CREATED"] = "CREATED";
    RevisionChangeType["PUBLISHED"] = "PUBLISHED";
    RevisionChangeType["DEACTIVATED"] = "DEACTIVATED";
    RevisionChangeType["IMPORTED"] = "IMPORTED";
})(RevisionChangeType || (RevisionChangeType = {}));
var RevisionState;
(function (RevisionState) {
    RevisionState["DRAFT"] = "DRAFT";
    RevisionState["PUBLISHED"] = "PUBLISHED";
    RevisionState["DEACTIVATED"] = "DEACTIVATED";
})(RevisionState || (RevisionState = {}));
var SavedExpertCuratedItemState;
(function (SavedExpertCuratedItemState) {
    SavedExpertCuratedItemState["DRAFT"] = "DRAFT";
    SavedExpertCuratedItemState["PUBLISHED"] = "PUBLISHED";
    SavedExpertCuratedItemState["ARCHIVED"] = "ARCHIVED";
})(SavedExpertCuratedItemState || (SavedExpertCuratedItemState = {}));
var SavedSellableReason;
(function (SavedSellableReason) {
    SavedSellableReason["PRICE"] = "PRICE";
    SavedSellableReason["STYLE"] = "STYLE";
    SavedSellableReason["HIGH_QUALITY"] = "HIGH_QUALITY";
    SavedSellableReason["BRAND"] = "BRAND";
    SavedSellableReason["FEATURES"] = "FEATURES";
})(SavedSellableReason || (SavedSellableReason = {}));
var ScheduledPaymentState;
(function (ScheduledPaymentState) {
    ScheduledPaymentState["SCHEDULED"] = "SCHEDULED";
    ScheduledPaymentState["EXECUTED"] = "EXECUTED";
    ScheduledPaymentState["CANCELED"] = "CANCELED";
})(ScheduledPaymentState || (ScheduledPaymentState = {}));
var SchedulingUserRole;
(function (SchedulingUserRole) {
    SchedulingUserRole["EXPERT"] = "EXPERT";
    SchedulingUserRole["ON_CALL_EXPERT"] = "ON_CALL_EXPERT";
    SchedulingUserRole["CHARTER_EXPERT"] = "CHARTER_EXPERT";
    SchedulingUserRole["ENTRY_EXPERT"] = "ENTRY_EXPERT";
})(SchedulingUserRole || (SchedulingUserRole = {}));
var ScrapingJobType;
(function (ScrapingJobType) {
    ScrapingJobType["SCRAPINGHUB"] = "SCRAPINGHUB";
})(ScrapingJobType || (ScrapingJobType = {}));
var ScrapingSellablePriceSourceSpider;
(function (ScrapingSellablePriceSourceSpider) {
    ScrapingSellablePriceSourceSpider["EVO"] = "EVO";
    ScrapingSellablePriceSourceSpider["PROGOLFYAKIMA"] = "PROGOLFYAKIMA";
    ScrapingSellablePriceSourceSpider["JENSONUSA"] = "JENSONUSA";
    ScrapingSellablePriceSourceSpider["BIKEBLING"] = "BIKEBLING";
    ScrapingSellablePriceSourceSpider["CHAINREACTIONCYCLES"] = "CHAINREACTIONCYCLES";
    ScrapingSellablePriceSourceSpider["CAMBRIABIKE"] = "CAMBRIABIKE";
})(ScrapingSellablePriceSourceSpider || (ScrapingSellablePriceSourceSpider = {}));
var SellableAttributePromotionRuleReferenceComparison;
(function (SellableAttributePromotionRuleReferenceComparison) {
    SellableAttributePromotionRuleReferenceComparison["EQUAL"] = "EQUAL";
    SellableAttributePromotionRuleReferenceComparison["NOT_EQUAL"] = "NOT_EQUAL";
})(SellableAttributePromotionRuleReferenceComparison || (SellableAttributePromotionRuleReferenceComparison = {}));
var SellableBadge;
(function (SellableBadge) {
    SellableBadge["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
    SellableBadge["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
    SellableBadge["SECRET_DEAL"] = "SECRET_DEAL";
})(SellableBadge || (SellableBadge = {}));
var SellableCategoryFilterPromotionRuleReferenceTraversalOption;
(function (SellableCategoryFilterPromotionRuleReferenceTraversalOption) {
    SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_PARENTS"] = "INCLUDE_PARENTS";
    SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_CHILDREN"] = "INCLUDE_CHILDREN";
})(SellableCategoryFilterPromotionRuleReferenceTraversalOption || (SellableCategoryFilterPromotionRuleReferenceTraversalOption = {}));
var SellableExpertCuratedItemNoteStatsSort;
(function (SellableExpertCuratedItemNoteStatsSort) {
    SellableExpertCuratedItemNoteStatsSort["APPROVED_COUNT"] = "APPROVED_COUNT";
    SellableExpertCuratedItemNoteStatsSort["PENDING_COUNT"] = "PENDING_COUNT";
    SellableExpertCuratedItemNoteStatsSort["REJECTED_COUNT"] = "REJECTED_COUNT";
    SellableExpertCuratedItemNoteStatsSort["PRODUCT_VIEWS"] = "PRODUCT_VIEWS";
})(SellableExpertCuratedItemNoteStatsSort || (SellableExpertCuratedItemNoteStatsSort = {}));
var SellablePriceSourceType;
(function (SellablePriceSourceType) {
    SellablePriceSourceType["DEAL"] = "DEAL";
    SellablePriceSourceType["AMAZON"] = "AMAZON";
    SellablePriceSourceType["EBAY"] = "EBAY";
    SellablePriceSourceType["SCRAPING"] = "SCRAPING";
    SellablePriceSourceType["YADAV"] = "YADAV";
    SellablePriceSourceType["RAW_SELLABLE_SCRAPER"] = "RAW_SELLABLE_SCRAPER";
    SellablePriceSourceType["RAW_SELLABLE_FEED"] = "RAW_SELLABLE_FEED";
    SellablePriceSourceType["RAW_SELLABLE_GOOGLE_PRODUCT"] = "RAW_SELLABLE_GOOGLE_PRODUCT";
    SellablePriceSourceType["RAW_SELLABLE_SHOPIFY"] = "RAW_SELLABLE_SHOPIFY";
    SellablePriceSourceType["DEAL_INVENTORY"] = "DEAL_INVENTORY";
    SellablePriceSourceType["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
})(SellablePriceSourceType || (SellablePriceSourceType = {}));
var SellableSearchFacetsQueryFilter;
(function (SellableSearchFacetsQueryFilter) {
    SellableSearchFacetsQueryFilter["FIRST_PRIMARY_ATTRIBUTE_ONLY"] = "FIRST_PRIMARY_ATTRIBUTE_ONLY";
    SellableSearchFacetsQueryFilter["ALL_PRIMARY_ATTRIBUTES"] = "ALL_PRIMARY_ATTRIBUTES";
    SellableSearchFacetsQueryFilter["FIRST_SECONDARY_ATTRIBUTE_ONLY"] = "FIRST_SECONDARY_ATTRIBUTE_ONLY";
    SellableSearchFacetsQueryFilter["ALL_SECONDARY_ATTRIBUTES"] = "ALL_SECONDARY_ATTRIBUTES";
    SellableSearchFacetsQueryFilter["INCLUDE_BRANDS"] = "INCLUDE_BRANDS";
    SellableSearchFacetsQueryFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
    SellableSearchFacetsQueryFilter["INCLUDE_GENDER"] = "INCLUDE_GENDER";
    SellableSearchFacetsQueryFilter["INCLUDE_SALE_PRICE_RANGE"] = "INCLUDE_SALE_PRICE_RANGE";
    SellableSearchFacetsQueryFilter["INCLUDE_DISCOUNTED_ONLY"] = "INCLUDE_DISCOUNTED_ONLY";
})(SellableSearchFacetsQueryFilter || (SellableSearchFacetsQueryFilter = {}));
var SellableSearchFilter;
(function (SellableSearchFilter) {
    SellableSearchFilter["DISCOUNTED"] = "DISCOUNTED";
    SellableSearchFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
    SellableSearchFilter["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
    SellableSearchFilter["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
    SellableSearchFilter["SECRET_DEAL"] = "SECRET_DEAL";
})(SellableSearchFilter || (SellableSearchFilter = {}));
var SellableSearchUseCase;
(function (SellableSearchUseCase) {
    SellableSearchUseCase["CONSUMER_SEARCH"] = "CONSUMER_SEARCH";
    SellableSearchUseCase["EXPERT_SEARCH"] = "EXPERT_SEARCH";
    SellableSearchUseCase["IMPERSONATE_CONSUMER"] = "IMPERSONATE_CONSUMER";
    SellableSearchUseCase["OPS_SEARCH"] = "OPS_SEARCH";
    SellableSearchUseCase["CONSUMER_HOME_PAGE_BY_BRANDS"] = "CONSUMER_HOME_PAGE_BY_BRANDS";
})(SellableSearchUseCase || (SellableSearchUseCase = {}));
var SellableServiceLocationDisplayType;
(function (SellableServiceLocationDisplayType) {
    SellableServiceLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(SellableServiceLocationDisplayType || (SellableServiceLocationDisplayType = {}));
var SellableSort;
(function (SellableSort) {
    SellableSort["AVG_SALE_PRICE"] = "AVG_SALE_PRICE";
    SellableSort["BEST_OFFER_PRICE"] = "BEST_OFFER_PRICE";
    SellableSort["MAX_PRICE_SAVINGS"] = "MAX_PRICE_SAVINGS";
    SellableSort["MAX_PRICE_PERCENT_SAVINGS"] = "MAX_PRICE_PERCENT_SAVINGS";
    SellableSort["POPULARITY"] = "POPULARITY";
    SellableSort["BEST_SELLER"] = "BEST_SELLER";
    SellableSort["RELEVANCE"] = "RELEVANCE";
    SellableSort["MOST_RECOMMENDED_BY_EXPERTS"] = "MOST_RECOMMENDED_BY_EXPERTS";
    SellableSort["INDEX_ORDER"] = "INDEX_ORDER";
    SellableSort["DOC_ID_ORDER"] = "DOC_ID_ORDER";
})(SellableSort || (SellableSort = {}));
var SellableSourceExternalIdType;
(function (SellableSourceExternalIdType) {
    SellableSourceExternalIdType["YADAV_DIAMOND"] = "YADAV_DIAMOND";
    SellableSourceExternalIdType["YADAV_SETTING"] = "YADAV_SETTING";
})(SellableSourceExternalIdType || (SellableSourceExternalIdType = {}));
var SellableSourceType;
(function (SellableSourceType) {
    SellableSourceType["URL"] = "URL";
    SellableSourceType["EXTERNAL_ID"] = "EXTERNAL_ID";
    SellableSourceType["STANDARDIZED_SELLABLE_GROUP"] = "STANDARDIZED_SELLABLE_GROUP";
})(SellableSourceType || (SellableSourceType = {}));
var SellableType;
(function (SellableType) {
    SellableType["PRODUCT"] = "PRODUCT";
    SellableType["SERVICE"] = "SERVICE";
})(SellableType || (SellableType = {}));
var ShiftAssignmentMode;
(function (ShiftAssignmentMode) {
    ShiftAssignmentMode["CLAIM"] = "CLAIM";
    ShiftAssignmentMode["RESERVE"] = "RESERVE";
    ShiftAssignmentMode["DRY_RUN"] = "DRY_RUN";
    ShiftAssignmentMode["NONE"] = "NONE";
})(ShiftAssignmentMode || (ShiftAssignmentMode = {}));
var ShiftSlotState;
(function (ShiftSlotState) {
    ShiftSlotState["SHIFTS_PROPOSED"] = "SHIFTS_PROPOSED";
    ShiftSlotState["SHIFTS_RESERVED"] = "SHIFTS_RESERVED";
    ShiftSlotState["SHIFTS_OPEN"] = "SHIFTS_OPEN";
})(ShiftSlotState || (ShiftSlotState = {}));
var ShippingMethod;
(function (ShippingMethod) {
    ShippingMethod["STANDARD"] = "STANDARD";
    ShippingMethod["EXPEDITED"] = "EXPEDITED";
})(ShippingMethod || (ShippingMethod = {}));
var ShippingPolicy;
(function (ShippingPolicy) {
    ShippingPolicy["NO_SHIPPING"] = "NO_SHIPPING";
    ShippingPolicy["FREE_SHIPPING"] = "FREE_SHIPPING";
    ShippingPolicy["PAID_BY_CUSTOMER"] = "PAID_BY_CUSTOMER";
})(ShippingPolicy || (ShippingPolicy = {}));
var ShippingStatus;
(function (ShippingStatus) {
    ShippingStatus["UNKNOWN"] = "UNKNOWN";
    ShippingStatus["IN_TRANSIT"] = "IN_TRANSIT";
    ShippingStatus["DELIVERED"] = "DELIVERED";
    ShippingStatus["FAILURE"] = "FAILURE";
    ShippingStatus["RETURNED"] = "RETURNED";
})(ShippingStatus || (ShippingStatus = {}));
var SimpleCuratedOrderType;
(function (SimpleCuratedOrderType) {
    SimpleCuratedOrderType["EXPERT_CONSULTATION_FEE"] = "EXPERT_CONSULTATION_FEE";
})(SimpleCuratedOrderType || (SimpleCuratedOrderType = {}));
var SocialMediaType;
(function (SocialMediaType) {
    SocialMediaType["FACEBOOK"] = "FACEBOOK";
    SocialMediaType["TWITTER"] = "TWITTER";
    SocialMediaType["LINKEDIN"] = "LINKEDIN";
    SocialMediaType["INSTAGRAM"] = "INSTAGRAM";
    SocialMediaType["PINTEREST"] = "PINTEREST";
    SocialMediaType["YOUTUBE"] = "YOUTUBE";
    SocialMediaType["STRAVA"] = "STRAVA";
})(SocialMediaType || (SocialMediaType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
var StandardizedSellableGroupCandidateState;
(function (StandardizedSellableGroupCandidateState) {
    StandardizedSellableGroupCandidateState["PENDING"] = "PENDING";
    StandardizedSellableGroupCandidateState["ACCEPTED"] = "ACCEPTED";
    StandardizedSellableGroupCandidateState["REJECTED"] = "REJECTED";
})(StandardizedSellableGroupCandidateState || (StandardizedSellableGroupCandidateState = {}));
var StandardizedSellableGroupState;
(function (StandardizedSellableGroupState) {
    StandardizedSellableGroupState["ACTIVE"] = "ACTIVE";
    StandardizedSellableGroupState["INACTIVE"] = "INACTIVE";
})(StandardizedSellableGroupState || (StandardizedSellableGroupState = {}));
var StandardizedSellableState;
(function (StandardizedSellableState) {
    StandardizedSellableState["ACTIVE"] = "ACTIVE";
    StandardizedSellableState["INACTIVE"] = "INACTIVE";
})(StandardizedSellableState || (StandardizedSellableState = {}));
var StringBinaryConditionDefinitionOperator;
(function (StringBinaryConditionDefinitionOperator) {
    StringBinaryConditionDefinitionOperator["IN"] = "IN";
    StringBinaryConditionDefinitionOperator["NOT_IN"] = "NOT_IN";
    StringBinaryConditionDefinitionOperator["EXISTS"] = "EXISTS";
    StringBinaryConditionDefinitionOperator["NOT_EXISTS"] = "NOT_EXISTS";
})(StringBinaryConditionDefinitionOperator || (StringBinaryConditionDefinitionOperator = {}));
var StringFieldType;
(function (StringFieldType) {
    StringFieldType["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    StringFieldType["DURATION"] = "DURATION";
    StringFieldType["JSON"] = "JSON";
})(StringFieldType || (StringFieldType = {}));
var StripeAuthenticationFlow;
(function (StripeAuthenticationFlow) {
    StripeAuthenticationFlow["REDIRECT"] = "redirect";
    StripeAuthenticationFlow["RECEIVER"] = "receiver";
    StripeAuthenticationFlow["CODE_VERIFICATION"] = "code_verification";
    StripeAuthenticationFlow["NONE"] = "none";
})(StripeAuthenticationFlow || (StripeAuthenticationFlow = {}));
var StripeCodeVerificationStatus;
(function (StripeCodeVerificationStatus) {
    StripeCodeVerificationStatus["PENDING"] = "pending";
    StripeCodeVerificationStatus["AWAITING_VERIFICATION"] = "awaiting_verification";
    StripeCodeVerificationStatus["SUCCEEDED"] = "succeeded";
    StripeCodeVerificationStatus["FAILED"] = "failed";
})(StripeCodeVerificationStatus || (StripeCodeVerificationStatus = {}));
var SuggestedActionType;
(function (SuggestedActionType) {
    SuggestedActionType["SEND_INITIAL_RESPONSE"] = "SEND_INITIAL_RESPONSE";
    SuggestedActionType["RESPOND_TO_NEW_MESSAGE"] = "RESPOND_TO_NEW_MESSAGE";
    SuggestedActionType["FOLLOW_UP"] = "FOLLOW_UP";
    SuggestedActionType["SNOOZE"] = "SNOOZE";
    SuggestedActionType["STAR"] = "STAR";
    SuggestedActionType["ARCHIVE"] = "ARCHIVE";
    SuggestedActionType["REQUEST_EXPERT_REVIEW"] = "REQUEST_EXPERT_REVIEW";
    SuggestedActionType["REQUEST_EXPERT_REFERRAL"] = "REQUEST_EXPERT_REFERRAL";
    SuggestedActionType["SEND_CURATION"] = "SEND_CURATION";
    SuggestedActionType["CLASSIFY_ARCHIVED_LEAD"] = "CLASSIFY_ARCHIVED_LEAD";
    SuggestedActionType["REVIEW_SURVEY"] = "REVIEW_SURVEY";
    SuggestedActionType["FULFILL_PROMISE"] = "FULFILL_PROMISE";
    SuggestedActionType["CURATION_VIEWED_FOLLOW_UP"] = "CURATION_VIEWED_FOLLOW_UP";
    SuggestedActionType["SELLABLE_VIEWED_FOLLOW_UP"] = "SELLABLE_VIEWED_FOLLOW_UP";
    SuggestedActionType["PRODUCT_ADDED_TO_CART_FOLLOW_UP"] = "PRODUCT_ADDED_TO_CART_FOLLOW_UP";
})(SuggestedActionType || (SuggestedActionType = {}));
var SuggestedSellableFilter;
(function (SuggestedSellableFilter) {
    SuggestedSellableFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
    SuggestedSellableFilter["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
    SuggestedSellableFilter["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
    SuggestedSellableFilter["SECRET_DEAL"] = "SECRET_DEAL";
})(SuggestedSellableFilter || (SuggestedSellableFilter = {}));
var SuggestedSellableReviewAnswer;
(function (SuggestedSellableReviewAnswer) {
    SuggestedSellableReviewAnswer["YES"] = "YES";
    SuggestedSellableReviewAnswer["NOT_SURE"] = "NOT_SURE";
    SuggestedSellableReviewAnswer["NO"] = "NO";
})(SuggestedSellableReviewAnswer || (SuggestedSellableReviewAnswer = {}));
var SuggestedSupportAction;
(function (SuggestedSupportAction) {
    SuggestedSupportAction["SUPPORT_RESPONSE_NEEDED"] = "SUPPORT_RESPONSE_NEEDED";
})(SuggestedSupportAction || (SuggestedSupportAction = {}));
var SuggestExpertCuratedItemNotesSort;
(function (SuggestExpertCuratedItemNotesSort) {
    SuggestExpertCuratedItemNotesSort["DEFAULT"] = "DEFAULT";
    SuggestExpertCuratedItemNotesSort["USAGES"] = "USAGES";
})(SuggestExpertCuratedItemNotesSort || (SuggestExpertCuratedItemNotesSort = {}));
var SupportTaskAction;
(function (SupportTaskAction) {
    SupportTaskAction["CREATE_TASK"] = "CREATE_TASK";
    SupportTaskAction["ASSIGN"] = "ASSIGN";
    SupportTaskAction["UNASSIGN"] = "UNASSIGN";
    SupportTaskAction["DISMISS"] = "DISMISS";
    SupportTaskAction["DELEGATE_LEAD"] = "DELEGATE_LEAD";
    SupportTaskAction["REASSIGN_LEAD"] = "REASSIGN_LEAD";
    SupportTaskAction["SUGGEST_LEAD_ACTIONS"] = "SUGGEST_LEAD_ACTIONS";
    SupportTaskAction["ESCALATE_LEAD_FOR_DELEGATION"] = "ESCALATE_LEAD_FOR_DELEGATION";
    SupportTaskAction["ESCALATE_LEAD_FOR_REASSIGNMENT"] = "ESCALATE_LEAD_FOR_REASSIGNMENT";
    SupportTaskAction["REQUEST_ORDER_SUPPORT_FOR_LEAD"] = "REQUEST_ORDER_SUPPORT_FOR_LEAD";
    SupportTaskAction["SNOOZE"] = "SNOOZE";
    SupportTaskAction["UNSNOOZE"] = "UNSNOOZE";
})(SupportTaskAction || (SupportTaskAction = {}));
var SupportTaskListEventType;
(function (SupportTaskListEventType) {
    SupportTaskListEventType["ADD"] = "ADD";
    SupportTaskListEventType["REMOVE"] = "REMOVE";
})(SupportTaskListEventType || (SupportTaskListEventType = {}));
var SupportTaskState;
(function (SupportTaskState) {
    SupportTaskState["PENDING"] = "PENDING";
    SupportTaskState["ASSIGNED"] = "ASSIGNED";
    SupportTaskState["COMPLETED"] = "COMPLETED";
})(SupportTaskState || (SupportTaskState = {}));
var SupportTaskType;
(function (SupportTaskType) {
    SupportTaskType["LEAD"] = "LEAD";
    SupportTaskType["ORDER"] = "ORDER";
})(SupportTaskType || (SupportTaskType = {}));
var SystemCuratedConsumerSellableReactionRating;
(function (SystemCuratedConsumerSellableReactionRating) {
    SystemCuratedConsumerSellableReactionRating["SKIP"] = "SKIP";
    SystemCuratedConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
    SystemCuratedConsumerSellableReactionRating["LIKE"] = "LIKE";
    SystemCuratedConsumerSellableReactionRating["LOVE"] = "LOVE";
})(SystemCuratedConsumerSellableReactionRating || (SystemCuratedConsumerSellableReactionRating = {}));
var SystemCuratedItemSurveyTerminationReason;
(function (SystemCuratedItemSurveyTerminationReason) {
    SystemCuratedItemSurveyTerminationReason["SKIPPED"] = "SKIPPED";
    SystemCuratedItemSurveyTerminationReason["TERMINATED_EARLY"] = "TERMINATED_EARLY";
    SystemCuratedItemSurveyTerminationReason["REVIEWED_ALL"] = "REVIEWED_ALL";
})(SystemCuratedItemSurveyTerminationReason || (SystemCuratedItemSurveyTerminationReason = {}));
var SystemCuratedItemType;
(function (SystemCuratedItemType) {
    SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER";
    SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED";
    SystemCuratedItemType["TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST"] = "TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST";
    SystemCuratedItemType["SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED"] = "SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED";
})(SystemCuratedItemType || (SystemCuratedItemType = {}));
var TagType;
(function (TagType) {
    TagType["BROADCAST_LEAD_QUALITY"] = "BROADCAST_LEAD_QUALITY";
    TagType["BROADCAST_CONVERSION_STRATEGY"] = "BROADCAST_CONVERSION_STRATEGY";
    TagType["BROADCAST_TRUST_STRATEGY"] = "BROADCAST_TRUST_STRATEGY";
    TagType["REMINDER_TASK_TYPE"] = "REMINDER_TASK_TYPE";
})(TagType || (TagType = {}));
var TemplateDataModelType;
(function (TemplateDataModelType) {
    TemplateDataModelType["DATA_OBJECT"] = "DATA_OBJECT";
    TemplateDataModelType["CUSTOM_QUERY"] = "CUSTOM_QUERY";
    TemplateDataModelType["NAMED_QUERIES"] = "NAMED_QUERIES";
})(TemplateDataModelType || (TemplateDataModelType = {}));
var TemplateFragmentParameterType;
(function (TemplateFragmentParameterType) {
    TemplateFragmentParameterType["TEXT"] = "TEXT";
    TemplateFragmentParameterType["BOOLEAN"] = "BOOLEAN";
    TemplateFragmentParameterType["OBJECT"] = "OBJECT";
    TemplateFragmentParameterType["IMAGE_URL"] = "IMAGE_URL";
    TemplateFragmentParameterType["ACTION_URL"] = "ACTION_URL";
    TemplateFragmentParameterType["ENUMERATION"] = "ENUMERATION";
})(TemplateFragmentParameterType || (TemplateFragmentParameterType = {}));
var TemplateFragmentType;
(function (TemplateFragmentType) {
    TemplateFragmentType["BLOCK"] = "BLOCK";
    TemplateFragmentType["HEADER"] = "HEADER";
    TemplateFragmentType["FOOTER"] = "FOOTER";
    TemplateFragmentType["BANNER"] = "BANNER";
    TemplateFragmentType["MODULE"] = "MODULE";
    TemplateFragmentType["PAGE_WRAPPER"] = "PAGE_WRAPPER";
    TemplateFragmentType["NONE"] = "NONE";
})(TemplateFragmentType || (TemplateFragmentType = {}));
var TemplateSearchSort;
(function (TemplateSearchSort) {
    TemplateSearchSort["PUBLISHED_AT"] = "PUBLISHED_AT";
    TemplateSearchSort["CREATED_AT"] = "CREATED_AT";
    TemplateSearchSort["TITLE"] = "TITLE";
})(TemplateSearchSort || (TemplateSearchSort = {}));
var TemplateTagSyntax;
(function (TemplateTagSyntax) {
    TemplateTagSyntax["DEFAULT"] = "DEFAULT";
    TemplateTagSyntax["ALTERNATIVE"] = "ALTERNATIVE";
})(TemplateTagSyntax || (TemplateTagSyntax = {}));
var TemplateTypeGroup;
(function (TemplateTypeGroup) {
    TemplateTypeGroup["ONBOARDING"] = "ONBOARDING";
    TemplateTypeGroup["NURTURING"] = "NURTURING";
    TemplateTypeGroup["FEEDBACK"] = "FEEDBACK";
    TemplateTypeGroup["CURATION"] = "CURATION";
    TemplateTypeGroup["EXPERT_ONBOARDING"] = "EXPERT_ONBOARDING";
    TemplateTypeGroup["MESSAGE_ROUTING"] = "MESSAGE_ROUTING";
    TemplateTypeGroup["EXPERT_NOTIFICATION"] = "EXPERT_NOTIFICATION";
    TemplateTypeGroup["POST_PURCHASE"] = "POST_PURCHASE";
    TemplateTypeGroup["CONSUMER_REQUEST"] = "CONSUMER_REQUEST";
    TemplateTypeGroup["CAMPAIGN"] = "CAMPAIGN";
    TemplateTypeGroup["ABANDONED_CART"] = "ABANDONED_CART";
    TemplateTypeGroup["ABANDONED_CHECKOUT"] = "ABANDONED_CHECKOUT";
    TemplateTypeGroup["PATH_DROPOFF"] = "PATH_DROPOFF";
    TemplateTypeGroup["FULFILLMENT"] = "FULFILLMENT";
    TemplateTypeGroup["REFERRAL"] = "REFERRAL";
})(TemplateTypeGroup || (TemplateTypeGroup = {}));
var ThreeDSecureVerification;
(function (ThreeDSecureVerification) {
    ThreeDSecureVerification["REQUIRED"] = "REQUIRED";
    ThreeDSecureVerification["RECOMMENDED"] = "RECOMMENDED";
    ThreeDSecureVerification["OPTIONAL"] = "OPTIONAL";
    ThreeDSecureVerification["NOT_SUPPORTED"] = "NOT_SUPPORTED";
})(ThreeDSecureVerification || (ThreeDSecureVerification = {}));
var TicketActionType;
(function (TicketActionType) {
    TicketActionType["CONTACT_CUSTOMER"] = "CONTACT_CUSTOMER";
    TicketActionType["CONTACT_MERCHANT"] = "CONTACT_MERCHANT";
    TicketActionType["CONTACT_EXPERT"] = "CONTACT_EXPERT";
    TicketActionType["GENERATE_SHIPPING_LABEL"] = "GENERATE_SHIPPING_LABEL";
    TicketActionType["VERIFY_ORDER"] = "VERIFY_ORDER";
    TicketActionType["UPDATE_TRACKING"] = "UPDATE_TRACKING";
    TicketActionType["REQUEST_CANCELLATION"] = "REQUEST_CANCELLATION";
    TicketActionType["REQUEST_REFUND"] = "REQUEST_REFUND";
    TicketActionType["UPDATE_ORDER"] = "UPDATE_ORDER";
    TicketActionType["MERGE_TICKETS"] = "MERGE_TICKETS";
    TicketActionType["TRANSFER_TICKET"] = "TRANSFER_TICKET";
})(TicketActionType || (TicketActionType = {}));
var TicketActivityType;
(function (TicketActivityType) {
    TicketActivityType["TICKET_ASSIGNED"] = "TICKET_ASSIGNED";
    TicketActivityType["TICKET_UNASSIGNED"] = "TICKET_UNASSIGNED";
    TicketActivityType["DUE_DATE_CHANGED"] = "DUE_DATE_CHANGED";
    TicketActivityType["FIELD_UPDATED"] = "FIELD_UPDATED";
    TicketActivityType["SNOOZE_CHANGED"] = "SNOOZE_CHANGED";
    TicketActivityType["TICKET_MERGED"] = "TICKET_MERGED";
    TicketActivityType["QUEUE_TRANSFER"] = "QUEUE_TRANSFER";
    TicketActivityType["TICKET_PICKED_UP"] = "TICKET_PICKED_UP";
    TicketActivityType["TICKET_CLOSED"] = "TICKET_CLOSED";
    TicketActivityType["TICKET_REOPENED"] = "TICKET_REOPENED";
    TicketActivityType["TICKET_CREATED"] = "TICKET_CREATED";
    TicketActivityType["DEPENDENCY_UPDATED"] = "DEPENDENCY_UPDATED";
})(TicketActivityType || (TicketActivityType = {}));
var TicketPriority;
(function (TicketPriority) {
    TicketPriority["NORMAL"] = "NORMAL";
    TicketPriority["HIGH"] = "HIGH";
})(TicketPriority || (TicketPriority = {}));
var TicketQueue;
(function (TicketQueue) {
    TicketQueue["FULFILLMENT_TIER_ONE"] = "FULFILLMENT_TIER_ONE";
    TicketQueue["FULFILLMENT_TIER_TWO"] = "FULFILLMENT_TIER_TWO";
    TicketQueue["SUPPORT_TIER_ONE"] = "SUPPORT_TIER_ONE";
    TicketQueue["SUPPORT_TIER_TWO"] = "SUPPORT_TIER_TWO";
})(TicketQueue || (TicketQueue = {}));
var TicketRequestChannel;
(function (TicketRequestChannel) {
    TicketRequestChannel["CUSTOMER_ESCALATION"] = "CUSTOMER_ESCALATION";
    TicketRequestChannel["EXPERT_CHAT"] = "EXPERT_CHAT";
    TicketRequestChannel["AGENT_ESCALATION"] = "AGENT_ESCALATION";
    TicketRequestChannel["EMAIL"] = "EMAIL";
    TicketRequestChannel["CALL"] = "CALL";
    TicketRequestChannel["WORKFLOW"] = "WORKFLOW";
})(TicketRequestChannel || (TicketRequestChannel = {}));
var TicketSearchSort;
(function (TicketSearchSort) {
    TicketSearchSort["CREATED_AT"] = "CREATED_AT";
    TicketSearchSort["UPDATED_AT"] = "UPDATED_AT";
    TicketSearchSort["DUE_AT"] = "DUE_AT";
})(TicketSearchSort || (TicketSearchSort = {}));
var TicketState;
(function (TicketState) {
    TicketState["OPEN"] = "OPEN";
    TicketState["BLOCKED"] = "BLOCKED";
    TicketState["ACTIVE"] = "ACTIVE";
    TicketState["SNOOZED"] = "SNOOZED";
    TicketState["CLOSED"] = "CLOSED";
})(TicketState || (TicketState = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["CLOSED"] = "CLOSED";
    TicketStatus["NEW"] = "NEW";
    TicketStatus["ASSIGNED"] = "ASSIGNED";
    TicketStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TicketStatus["RESOLVED"] = "RESOLVED";
    TicketStatus["BLOCKED"] = "BLOCKED";
    TicketStatus["WONT_COMPLETE"] = "WONT_COMPLETE";
})(TicketStatus || (TicketStatus = {}));
var TicketType;
(function (TicketType) {
    TicketType["LINE_ITEM_CLAIM"] = "LINE_ITEM_CLAIM";
    TicketType["UPDATE_TRACKING_INFO"] = "UPDATE_TRACKING_INFO";
    TicketType["ORDER_VERIFICATION"] = "ORDER_VERIFICATION";
    TicketType["PRODUCT_RETURN"] = "PRODUCT_RETURN";
    TicketType["CONSUMER_REFUND"] = "CONSUMER_REFUND";
    TicketType["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    TicketType["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
    TicketType["MISSING_SPECS"] = "MISSING_SPECS";
    TicketType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
    TicketType["CANCELLATION"] = "CANCELLATION";
    TicketType["RETURN"] = "RETURN";
    TicketType["EXCHANGE"] = "EXCHANGE";
    TicketType["MISSING_ITEM"] = "MISSING_ITEM";
    TicketType["TRACKING_INQUIRY"] = "TRACKING_INQUIRY";
    TicketType["ORDER_INFORMATION"] = "ORDER_INFORMATION";
    TicketType["OTHER"] = "OTHER";
    TicketType["FOLLOWUP_ACTION_REQUEST"] = "FOLLOWUP_ACTION_REQUEST";
    TicketType["GROUPED_ITEM_CLAIMS"] = "GROUPED_ITEM_CLAIMS";
})(TicketType || (TicketType = {}));
var TipMethodType;
(function (TipMethodType) {
    TipMethodType["PERCENT_OF_AMOUNT"] = "PERCENT_OF_AMOUNT";
    TipMethodType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(TipMethodType || (TipMethodType = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["SUCCESS"] = "SUCCESS";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["IN_REVIEW"] = "IN_REVIEW";
    TransactionStatus["FAILURE"] = "FAILURE";
    TransactionStatus["REFUNDED"] = "REFUNDED";
    TransactionStatus["OFFLINE"] = "OFFLINE";
})(TransactionStatus || (TransactionStatus = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["CUSTOMER"] = "CUSTOMER";
    TransactionType["MERCHANT"] = "MERCHANT";
})(TransactionType || (TransactionType = {}));
var TransferTicketReason;
(function (TransferTicketReason) {
    TransferTicketReason["NEED_TO_CONTACT_CUSTOMER"] = "NEED_TO_CONTACT_CUSTOMER";
    TransferTicketReason["NEED_TO_CONTACT_MERCHANT"] = "NEED_TO_CONTACT_MERCHANT";
    TransferTicketReason["OTHER"] = "OTHER";
    TransferTicketReason["CUSTOMER_EXCEPTION"] = "CUSTOMER_EXCEPTION";
    TransferTicketReason["CLAIM_ITEM"] = "CLAIM_ITEM";
    TransferTicketReason["UNABLE_TO_VERIFY"] = "UNABLE_TO_VERIFY";
})(TransferTicketReason || (TransferTicketReason = {}));
var TriggerChangeType;
(function (TriggerChangeType) {
    TriggerChangeType["CREATED"] = "CREATED";
    TriggerChangeType["PUBLISHED"] = "PUBLISHED";
    TriggerChangeType["DEACTIVATED"] = "DEACTIVATED";
    TriggerChangeType["ARCHIVED"] = "ARCHIVED";
    TriggerChangeType["IMPORTED"] = "IMPORTED";
})(TriggerChangeType || (TriggerChangeType = {}));
var TriggerConditionType;
(function (TriggerConditionType) {
    TriggerConditionType["LOGICAL"] = "LOGICAL";
    TriggerConditionType["BINARY"] = "BINARY";
    TriggerConditionType["EXPERIMENT"] = "EXPERIMENT";
})(TriggerConditionType || (TriggerConditionType = {}));
var TriggerDelayIntervalType;
(function (TriggerDelayIntervalType) {
    TriggerDelayIntervalType["FIXED"] = "FIXED";
    TriggerDelayIntervalType["DYNAMIC"] = "DYNAMIC";
    TriggerDelayIntervalType["WITH_EXPERIMENT"] = "WITH_EXPERIMENT";
})(TriggerDelayIntervalType || (TriggerDelayIntervalType = {}));
var TriggerDurationUnit;
(function (TriggerDurationUnit) {
    TriggerDurationUnit["SECONDS"] = "SECONDS";
    TriggerDurationUnit["MINUTES"] = "MINUTES";
    TriggerDurationUnit["HOURS"] = "HOURS";
    TriggerDurationUnit["DAYS"] = "DAYS";
})(TriggerDurationUnit || (TriggerDurationUnit = {}));
var TriggerFieldType;
(function (TriggerFieldType) {
    TriggerFieldType["BOOLEAN"] = "BOOLEAN";
    TriggerFieldType["INTEGER"] = "INTEGER";
    TriggerFieldType["DECIMAL"] = "DECIMAL";
    TriggerFieldType["STRING"] = "STRING";
    TriggerFieldType["STRING_LIST"] = "STRING_LIST";
    TriggerFieldType["DATE"] = "DATE";
    TriggerFieldType["ID"] = "ID";
    TriggerFieldType["ID_LIST"] = "ID_LIST";
})(TriggerFieldType || (TriggerFieldType = {}));
var TriggerNodeEdgeType;
(function (TriggerNodeEdgeType) {
    TriggerNodeEdgeType["NEXT"] = "NEXT";
    TriggerNodeEdgeType["TRUE"] = "TRUE";
    TriggerNodeEdgeType["FALSE"] = "FALSE";
})(TriggerNodeEdgeType || (TriggerNodeEdgeType = {}));
var TriggerNodeType;
(function (TriggerNodeType) {
    TriggerNodeType["DELAY"] = "DELAY";
    TriggerNodeType["FILTER"] = "FILTER";
    TriggerNodeType["BRANCH"] = "BRANCH";
    TriggerNodeType["ACTION"] = "ACTION";
    TriggerNodeType["WAIT"] = "WAIT";
})(TriggerNodeType || (TriggerNodeType = {}));
var TriggerParameterType;
(function (TriggerParameterType) {
    TriggerParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
    TriggerParameterType["EVENT_PARAMETER"] = "EVENT_PARAMETER";
    TriggerParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
})(TriggerParameterType || (TriggerParameterType = {}));
var TriggerSearchSort;
(function (TriggerSearchSort) {
    TriggerSearchSort["CREATED_AT"] = "CREATED_AT";
    TriggerSearchSort["PUBLISHED_AT"] = "PUBLISHED_AT";
    TriggerSearchSort["TITLE"] = "TITLE";
})(TriggerSearchSort || (TriggerSearchSort = {}));
var TriggerState;
(function (TriggerState) {
    TriggerState["DRAFT"] = "DRAFT";
    TriggerState["TEST"] = "TEST";
    TriggerState["PUBLISHED"] = "PUBLISHED";
    TriggerState["DEACTIVATED"] = "DEACTIVATED";
    TriggerState["ARCHIVED"] = "ARCHIVED";
})(TriggerState || (TriggerState = {}));
var UnsavedSellableReason;
(function (UnsavedSellableReason) {
    UnsavedSellableReason["NOT_INTERESTED"] = "NOT_INTERESTED";
    UnsavedSellableReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
    UnsavedSellableReason["LOW_QUALITY"] = "LOW_QUALITY";
    UnsavedSellableReason["UGLY"] = "UGLY";
    UnsavedSellableReason["DONT_NEED"] = "DONT_NEED";
    UnsavedSellableReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
})(UnsavedSellableReason || (UnsavedSellableReason = {}));
var UpdateUserSourceToConsumerReferralErrorCode;
(function (UpdateUserSourceToConsumerReferralErrorCode) {
    UpdateUserSourceToConsumerReferralErrorCode["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    UpdateUserSourceToConsumerReferralErrorCode["REFERRER_NOT_FOUND"] = "REFERRER_NOT_FOUND";
})(UpdateUserSourceToConsumerReferralErrorCode || (UpdateUserSourceToConsumerReferralErrorCode = {}));
var UserActivityType;
(function (UserActivityType) {
    UserActivityType["ADD_SELLABLE"] = "ADD_SELLABLE";
    UserActivityType["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
    UserActivityType["COMPLETE_ORDER"] = "COMPLETE_ORDER";
    UserActivityType["CURATED_LIST_VIEWED"] = "CURATED_LIST_VIEWED";
    UserActivityType["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
    UserActivityType["REMOVE_SELLABLE"] = "REMOVE_SELLABLE";
    UserActivityType["SEARCH_SELLABLES"] = "SEARCH_SELLABLES";
    UserActivityType["VIEW_CART"] = "VIEW_CART";
    UserActivityType["VIEW_SELLABLE"] = "VIEW_SELLABLE";
    UserActivityType["VOICE_CALL"] = "VOICE_CALL";
    UserActivityType["SAVED_SELLABLE"] = "SAVED_SELLABLE";
    UserActivityType["UNSAVED_SELLABLE"] = "UNSAVED_SELLABLE";
})(UserActivityType || (UserActivityType = {}));
var UserEditErrorCode;
(function (UserEditErrorCode) {
    UserEditErrorCode["FIRST_NAME_REQUIRED"] = "FIRST_NAME_REQUIRED";
    UserEditErrorCode["INVALID_CONTACT"] = "INVALID_CONTACT";
})(UserEditErrorCode || (UserEditErrorCode = {}));
var UserJourneyLeadStageStatus;
(function (UserJourneyLeadStageStatus) {
    UserJourneyLeadStageStatus["NO_CURATION"] = "NO_CURATION";
    UserJourneyLeadStageStatus["CURATION_READY"] = "CURATION_READY";
    UserJourneyLeadStageStatus["OLD_CURATION"] = "OLD_CURATION";
})(UserJourneyLeadStageStatus || (UserJourneyLeadStageStatus = {}));
var UserJourneyOrderStageStatus;
(function (UserJourneyOrderStageStatus) {
    UserJourneyOrderStageStatus["PLACED"] = "PLACED";
    UserJourneyOrderStageStatus["IN_TRANSIT"] = "IN_TRANSIT";
    UserJourneyOrderStageStatus["DELIVERED"] = "DELIVERED";
})(UserJourneyOrderStageStatus || (UserJourneyOrderStageStatus = {}));
var UserJourneyStageType;
(function (UserJourneyStageType) {
    UserJourneyStageType["NEW"] = "NEW";
    UserJourneyStageType["LEAD"] = "LEAD";
    UserJourneyStageType["ORDER"] = "ORDER";
})(UserJourneyStageType || (UserJourneyStageType = {}));
var UserSourceType;
(function (UserSourceType) {
    UserSourceType["ADS"] = "ADS";
    UserSourceType["REFERRAL"] = "REFERRAL";
    UserSourceType["EXPERT_REFERRAL"] = "EXPERT_REFERRAL";
    UserSourceType["PHONE_CALL"] = "PHONE_CALL";
    UserSourceType["SMS"] = "SMS";
    UserSourceType["EMAIL"] = "EMAIL";
    UserSourceType["INVESTOR"] = "INVESTOR";
    UserSourceType["PARTNER"] = "PARTNER";
    UserSourceType["ORGANIC"] = "ORGANIC";
})(UserSourceType || (UserSourceType = {}));
var VerifyPendingAccessContactErrorCode;
(function (VerifyPendingAccessContactErrorCode) {
    VerifyPendingAccessContactErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
})(VerifyPendingAccessContactErrorCode || (VerifyPendingAccessContactErrorCode = {}));
var WorkflowFailureResolution;
(function (WorkflowFailureResolution) {
    WorkflowFailureResolution["RETRY_WORKFLOW"] = "RETRY_WORKFLOW";
    WorkflowFailureResolution["AUTO_ESCALATE"] = "AUTO_ESCALATE";
    WorkflowFailureResolution["MANUAL_ESCALATE"] = "MANUAL_ESCALATE";
})(WorkflowFailureResolution || (WorkflowFailureResolution = {}));
var WorkflowType;
(function (WorkflowType) {
    WorkflowType["BASIC"] = "BASIC";
    WorkflowType["FULFILLMENT"] = "FULFILLMENT";
})(WorkflowType || (WorkflowType = {}));

export { AcceptEscalationResultStatus, AcceptRequestMode, AirportType, ArticleContentBlockType, ArticleRevisionState, ArticleSort, AssignActionReason, AttentionNeededLeadChangeType, AttributeFunction, AttributeSchemaMetadataType, AttributeSchemaRevisionQueryDraftFilter, AttributeSchemaRevisionSort, AttributeSchemaRevisionState, AttributeSearchFunction, AttributeType, AttributeValidatorType, AttributedHtmlTextViewModelAttributeType, AuthenticationMethod, AuthenticationResult, AwayAutoReplyStatus, BookingSearchSort, BookingState, BroadcastOfferType, BusinessUserActivityType, BusinessUserState, CallStatus, CallType, CardFieldValidationStatus, CardFundingType, CartSyncUseCase, CategoryType, ChallengeType, ChannelType, ClaimPromotionErrorCode, CloseTicketReason, ConditionType, ConsumerInitialLeadAction, ConsumerReviewSearchSort, ConsumerReviewSource, ConsumerSellableReactionRating, ConsumerSellableReactionReason, ConsumerSellableReactionSource, ContactType, ContentSelectionAdLevel, ContentSelectionChannelType, ContentSelectionDeviceType, DatePathFlowQuestionType, DateRangeFilterField, DateRangePathFlowQuestionType, DealState, DealTermsType, DepartmentNavigationLabelStyle, DepartmentNavigationResponsiveFullSizeOptions, DepartmentNavigationResponsiveSmallSizeOptions, DepartmentType, DependencyUpdateType, DurationUnit, EditableUserSourceType, EmbedMediaType, Environment, EscalationItemCondition, EscalationResolution, ExperimentSortBy, ExperimentState, ExpertApplicationFolderItemChangeType, ExpertApplicationFolderType, ExpertApplicationRating, ExpertApplicationSearchSort, ExpertApplicationState, ExpertApplicationSubscriptionChangeType, ExpertApplicationTaskState, ExpertApplicationTaskType, ExpertCuratedItemNoteSort, ExpertCuratedItemNoteState, ExpertCuratedItemPriceOverrideReasonType, ExpertCuratedItemRankChangeType, ExpertCuratedItemRemovedReason, ExpertCuratedItemSort, ExpertCuratedItemStateFilter, ExpertCuratedItemTagType, ExpertCuratedOrderClosedReason, ExpertCuratedOrderSelectErrorCode, ExpertCuratedOrderServiceLocationErrorCode, ExpertCuratedOrderState, ExpertCuratedOrdersForLeadQueryCustomFilter, ExpertCuratedOrdersForLeadQueryDraftFilter, ExpertGender, ExpertHiringFeedbackState, ExpertHiringFeedbackType, ExpertLeadFolderGroupType, ExpertLeadFolderItemChangeType, ExpertNoteVisibilityType, ExpertNotificationMode, ExpertNotificationType, ExpertPerformanceRating, ExpertPresenceStatus, ExpertProfileState, ExpertRecommendationStrategy, ExpertSearchSort, ExternalAdPlatform, ExternalAdStatus, ExternalInventoryItemSourceType, ExternalProfileType, ExternalVideoIdType, FacetImageType, FlightPlanEditErrorCode, FlightPlanState, FrontendTaskStatus, FulfillmentChannelType, FulfillmentOrderDeliveryStatus, FulfillmentOrderSourceType, FulfillmentServiceProvider, FulfillmentServiceType, FulfillmentStatus, FulfillmentSuggestionStatus, GuestConversationSequenceState, HandleType, IdPathFlowQuestionType, IdentityType, InputTextPathFlowQuestionFieldType, InputTextPathFlowQuestionValidationType, InterstitialPathFlowPageMetadataType, LeadActivityType, LeadCampaignRecipientSortOrder, LeadCampaignState, LeadCampaignTriggerExecutionInterval, LeadEscalationLevel, LeadEscalationStatus, LeadEscalationType, LeadExpertRole, LeadIntentLabel, LeadParticipantType, LeadReassignmentReason, LeadSortOrder, LeadSupportTaskReason, ListPathFlowQuestionRenderStyle, ListPathFlowQuestionType, LogicalConditionOperator, LogicalOperator, LookupReferralCodeError, LtvType, MessageBodyType, MessageRichCardType, MessageUnsubscribeTag, MessagingChannelType, MessagingUserType, MonetaryAmountDenominationType, NumericPathFlowQuestionDisplayType, NumericPathFlowQuestionUnitType, NumericPathFlowQuestionValueType, NumericRangeDisplayFacetType, OAuthType, OfferState, OperatorPermission, OperatorRole, OrderActivityDetailType, OrderChargeableStatusType, OrderChargeableUseCase, OrderCostComponent, OrderEscalationLabel, OrderEscalationPriority, OrderEscalationSearchSort, OrderEscalationSource, OrderEscalationStatus, OrderEscalationType, OrderFulfillmentState, OrderLabel, OrderLineItemGroupPriceStrategy, OrderLineItemGroupTaxStrategy, OrderLineItemSourceType, OrderLineItemState, OrderLineItemsGroupingType, OrderPreSubmitAction, OrderRefundReason, OrderRefundStatus, OrderRefundType, OrderSearchSort, OrderState, PathFlowOnCompleteRedirectLocation, PathFlowPageMetadataType, PathFlowThemeType, PathValidationErrorTag, PayComponentType, PayLineItemSortField, PayStructureRevisionState, PaymentActivityType, PaymentMethod, PaymentProcessorType, PaymentSourceStatus, PaymentSourceUsage, PaymentVerificationMethod, PayoutSortField, PayoutState, Permission, PostalAddressLocationDisplayType, PresenceStatus, ProductCondition, ProductReturnDestination, ProfileHighlightIconType, ProfileHighlightSource, ProfileHighlightValueType, PromotionActionType, PromotionDisabledReason, PromotionQueryFlagType, PromotionRuleComparisonOperator, PromotionRuleFilterStrategy, PromotionRuleType, PromotionSourceType, PromotionState, RawSellableAttributeValuePatternFlag, RawSellableSourceState, RawSellableSourceType, RawSellableStandardizationActionType, RawSellableStandardizationRuleConditionType, RawSellableStandardizationRuleFieldType, RawSellableStandardizationRuleParameterType, RawSellableStandardizationRuleState, RawSellableState, RecommendedListType, ReferralMedium, ReferralType, ReferrerIncentiveType, RegisterCustomerErrorCode, ReopenTicketReason, ReportAccessScope, ReportColumnFormat, ReportColumnValueType, ReportSchemaType, ReturnPolicyType, ReturnRefundMethod, ReturnShippingPaidBy, RevisionChangeType, RevisionState, SavedExpertCuratedItemState, SavedSellableReason, ScheduledPaymentState, SchedulingUserRole, ScrapingJobType, ScrapingSellablePriceSourceSpider, SellableAttributePromotionRuleReferenceComparison, SellableBadge, SellableCategoryFilterPromotionRuleReferenceTraversalOption, SellableExpertCuratedItemNoteStatsSort, SellablePriceSourceType, SellableSearchFacetsQueryFilter, SellableSearchFilter, SellableSearchUseCase, SellableServiceLocationDisplayType, SellableSort, SellableSourceExternalIdType, SellableSourceType, SellableType, ShiftAssignmentMode, ShiftSlotState, ShippingMethod, ShippingPolicy, ShippingStatus, SimpleCuratedOrderType, SocialMediaType, SortOrder, StandardizedSellableGroupCandidateState, StandardizedSellableGroupState, StandardizedSellableState, StringBinaryConditionDefinitionOperator, StringFieldType, StripeAuthenticationFlow, StripeCodeVerificationStatus, SuggestExpertCuratedItemNotesSort, SuggestedActionType, SuggestedSellableFilter, SuggestedSellableReviewAnswer, SuggestedSupportAction, SupportTaskAction, SupportTaskListEventType, SupportTaskState, SupportTaskType, SystemCuratedConsumerSellableReactionRating, SystemCuratedItemSurveyTerminationReason, SystemCuratedItemType, TagType, TemplateDataModelType, TemplateFragmentParameterType, TemplateFragmentType, TemplateSearchSort, TemplateTagSyntax, TemplateTypeGroup, ThreeDSecureVerification, TicketActionType, TicketActivityType, TicketPriority, TicketQueue, TicketRequestChannel, TicketSearchSort, TicketState, TicketStatus, TicketType, TipMethodType, TransactionStatus, TransactionType, TransferTicketReason, TriggerChangeType, TriggerConditionType, TriggerDelayIntervalType, TriggerDurationUnit, TriggerFieldType, TriggerNodeEdgeType, TriggerNodeType, TriggerParameterType, TriggerSearchSort, TriggerState, UnsavedSellableReason, UpdateUserSourceToConsumerReferralErrorCode, UserActivityType, UserEditErrorCode, UserJourneyLeadStageStatus, UserJourneyOrderStageStatus, UserJourneyStageType, UserSourceType, VerifyPendingAccessContactErrorCode, WorkflowFailureResolution, WorkflowType };
//# sourceMappingURL=graphql.js.map
